import React, { Component } from "react";
import { Row, Col, Button } from "reactstrap";
import { array, string, func } from "prop-types";
import { withRouter } from "react-router-dom";
import _ from "lodash";
import toastr from 'COMPONENTS/ShowTostr/ShowTostr';
import { toast, Slide } from "react-toastify";

import Popup from "COMPONENTS/CommonComponents/Modal/Modal";
import EndSessionConfirmationModal from "COMPONENTS/CommonComponents/Modal/Modal";
import AppEmulationContainer from "COMPONENTS/AppEmulation/AppEmulationContainer";
import AddInviteeContainer from "COMPONENTS/AddInvitee/AddInviteeContainer";

import { getMessage } from "CONFIG/i18n";
import { CO_BROWSE_LAYOUT, DeactiveModules } from "UTILS/Constants";

import { socketMessage, webRtcMessageId, mediaType, mediaStatus } from "WEBSOCKET/constants";
import { isDesktop, isIE, isMacOs, isMobileOnly, isSafari, isTablet } from 'react-device-detect';

// header center
import ic_audio from "ASSETS/Images/header_center/ic_audio_deactivate.svg";
import ic_audio_active from "ASSETS/Images/header_center/ic_audio_activate.svg";
import ic_audio_disabled from "ASSETS/Images/header_center/ic_audio_disable.svg";
import ic_canvas from "ASSETS/Images/header_center/ic_canvas_deactivate.svg";
import ic_canvas_active from "ASSETS/Images/header_center/ic_canvas_activate.svg";
import ic_canvas_disabled from "ASSETS/Images/header_center/ic_canvas_disable.svg";
import ic_message from "ASSETS/Images/header_center/ic_message_deactivate.svg";
import ic_message_active from "ASSETS/Images/header_center/ic_message_activate.svg";
import ic_message_disabled from "ASSETS/Images/header_center/ic_message_disable.svg";
import ic_video from "ASSETS/Images/header_center/ic_video_deactivate.svg";
import ic_video_active from "ASSETS/Images/header_center/ic_video_activate.svg";
import ic_video_disabled from "ASSETS/Images/header_center/ic_video_disable.svg";
import ic_share from "ASSETS/Images/header_center/ic_share_deactivate.svg";
import ic_share_active from "ASSETS/Images/header_center/ic_share_activate.svg";
import ic_share_disabled from "ASSETS/Images/header_center/ic_share_disable.svg";
import ic_location from "ASSETS/Images/header_center/ic_location_deactivate.svg";
import ic_location_active from "ASSETS/Images/header_center/ic_location_activate.svg";
import ic_location_disabled from "ASSETS/Images/header_center/ic_location_disable.svg";
import ic_cobrowse from "ASSETS/Images/header_center/ic_co_browse_deactivate.svg";
import ic_cobrowse_active from "ASSETS/Images/header_center/ic_co_browse_activate.svg";
import ic_cobrowse_disabled from "ASSETS/Images/header_center/ic_co_browse_disable.svg";
import ic_snapshot from "ASSETS/Images/header_center/ic_snapshot_deactivate.svg";
import ic_snapshot_active from "ASSETS/Images/header_center/ic_snapshot_activate.svg";
import ic_snapshot_disabled from "ASSETS/Images/header_center/ic_snapshot_disable.svg";
import ic_contract_information_deactivate from 'ASSETS/Images/header_center/ic_contract_information_deactivate.svg';

// 削除予定
import ic_app_emulation from "ASSETS/Images/ic_app_emulation.svg";

// header right
import ic_participants from "ASSETS/Images/header_right/ic_participants.svg";
import ic_save_icon from "ASSETS/Images/header_right/ic_save.svg";
import ic_rec_start_icon from "ASSETS/Images/header_right/ic_rec_start.svg";
import ic_rec_stop_icon from "ASSETS/Images/header_right/ic_rec_stop.svg";
import ic_screen_masking_start from "ASSETS/Images/header_right/ic_mask_start.svg";
import ic_screen_masking_stop from "ASSETS/Images/header_right/ic_mask_stop.svg";
import ic_menu from "ASSETS/Images/header_right/ic_menu.svg";

import "./Header.less";

import ChatContainer from "COMPONENTS/Chat/ChatContainer";
import LocationContainer from "COMPONENTS/Location/LocationContainer";
import Spinner from "COMPONENTS/Spinner/Spinner";
import WaitingArea from "COMPONENTS/WaitingArea/WaitingArea";
import AdmitTostr from "COMPONENTS/ShowTostr/AdmitTostr";
import Participants from "./Participants/Participants";
import PreviewModal from "COMPONENTS/Video/Preview/Preview";

// CONSTANTS
import {
  Modules, USER_ROLES, SESSION_STATUS,
  LANGUAGE, USER_ADMISSION_STATUS, CONFIG,
  FONT_FAMILY, CO_BROWSE_SESSION_STATUS, cobrowseTypes, CUSTOMER_CO_BROWSE_ACTIONS, CUSTOMER_CO_BROWSE_RESPONSE,
  RECORDING_METHOD, TOAST_ID, SCREEN_MASK_MODE, PARTICIPANT_STATUS,
  FILTER_NAME,
} from "UTILS/Constants";
import {
  isWebRTCSupported, isMobileOriPad, isAndroidOrIos,
  getUserMediaError, isModuleIconToBeDisabled, getUserNameForSelectedLanguage, isWebRTCPluginInstalled, postMesageToCoBrowseIframeUtility,
  getMediaConstraints
} from "UTILS/Utility";

// Actions
import {
  leaveSessionAction,
  headerAction,
  customerCoBrowseAction,
  customerCoBrowseActionV2,
} from "CONFIG/ActionFactory";

class Header extends Component {
  static propTypes = {
    modules: array,
    sessionTitle: string,
    admittedParticipants: array.isRequired,
    allParticipants: array.isRequired,
    sessionKey: string,
    sendWebsocketMessage: func,
    token: string,
    userRole: string,
    handleEndSession: func
  };

  state = {
    popoverOpen: false,
    chatPopOver: false,
    isMessageArrived: false,
    addInvitee: false,
    makePresenterPopoverOpen: "",
    locationPopOver: false,
    spinnerVisibility: false,
    showDeviceListModal: false,
    showEndSessionConfirmationModal: false,
    showLeaveSessionConfirmationModal: false,
    sortedParticipants: [],
    sessionLink: "",
    isDeviceAttached: null,
    showSnapshotModal: false,
    isButtonClicked: false,
    isSnapshotPermissionButtonClicked: false,
    moreParticipantsPopOver: false,
    showWaitingArea: false,
    showPreviewModal: false,
    iconLarge: this.props.iconLargeSettings ? this.props.iconLargeSettings.isEnable || false : false,
    isReductionLogs: this.props.isReductionLogs ? (this.props.isReductionLogs.isEnable ? true : false) : false,
    disableCanvasEdit: this.props.disableCanvasEdit ? this.props.disableCanvasEdit.isEnable || false : false,
  };

  constructor(props) {
    super(props);
    this.reloadReduction = false;
    this.headerIconClickActions = {
      handleAudioToggle: this.handleAudioToggle,
      handleAudioVideoToggle: this.props.isEnableShowPreview ? this.handleShowAudioVideoPreview : this.handleAudioVideoToggle,
      handleScreenShareToggle: this.handleScreenShareToggle,
      handleChatToggle: this.handleChatToggle,
      handleLocationToggle: this.handleLocationToggle,
      handleAppEmulationToggle: this.handleAppEmulationToggle,
      handleSnapshot: this.handleSnapshot,
      handleTargetSiteSelectionModalToggle: () => this.handleTargetSiteSelectionModalToggle(true),
      toggleContractInfoModal: this.toggleContractInfoModal,
    };
  }

  componentDidMount() {
    window.addEventListener("resize", () => {
      this.hideSideDrawer();
      this.setState({
        moreParticipantsPopOver: false,
        makePresenterPopoverOpen: false
      });
    });
    window.addEventListener("message", this.getIframeMsg, false);

    const modules = this.props.modules;

    this.getBaseUrl();
    if (modules) {
      const modulesInfo = {
        CANVAS: {
          logo: ic_canvas_active,
          class: "moduleIconActive cursorDisabled",
          title: getMessage("CANVAS"),
          userAllowed: true,
          textLabelClass: " cursorDisabled",
          logo_disable: ic_canvas_disabled,
          logo_active: ic_canvas_active,
          logo_deactive: ic_canvas,
        }
      };
      if (modules.indexOf(Modules.AUDIO) !== -1) {
        modulesInfo.AUDIO = {
          logo: (this.props.userRole === USER_ROLES.USER) ? ic_audio_disabled : ic_audio,
          class: (this.props.userRole === USER_ROLES.USER) ? "moduleIcon cursorDisabled" : "moduleIcon",
          clickAction: "handleAudioToggle",
          title: getMessage("AUDIO"),
          userAllowed: false,
          textLabelClass: (this.props.userRole === USER_ROLES.USER) ? " cursorDisabled" : " cursorPointer",
          logo_disable: ic_audio_disabled,
          logo_active: ic_audio_active,
          logo_deactive: ic_audio,
        };
      }
      if (modules.indexOf(Modules.AUDIO_VIDEO) !== -1) {
        modulesInfo.AUDIO_VIDEO = {
          logo: (this.props.userRole === USER_ROLES.USER) ? ic_video_disabled : ic_video,
          class: (this.props.userRole === USER_ROLES.USER) ? "moduleIcon cursorDisabled" : "moduleIcon",
          clickAction: "handleAudioVideoToggle",
          title: getMessage("AUDIO_VIDEO"),
          userAllowed: false,
          textLabelClass: (this.props.userRole === USER_ROLES.USER) ? " cursorDisabled" : " cursorPointer",
          logo_disable: ic_video_disabled,
          logo_active: ic_video_active,
          logo_deactive: ic_video,
        };
      }
      if (modules.indexOf(Modules.CHAT) !== -1) {
        modulesInfo.CHAT = {
          logo: ic_message,
          class: "moduleIcon",
          clickAction: "handleChatToggle",
          title: getMessage("CHAT"),
          userAllowed: true,
          textLabelClass: " cursorPointer",
          logo_disable: ic_message_disabled,
          logo_active: ic_message_active,
          logo_deactive: ic_message,
        };
      }
      if (modules.indexOf(Modules.LOCATION) !== -1 &&
        this.props.userRole === USER_ROLES.AGENT) {
        modulesInfo.LOCATION = {
          logo: (this.props.userRole === USER_ROLES.USER) ? ic_location_disabled : ic_location,
          class: (this.props.userRole === USER_ROLES.USER) ? "moduleIcon cursorDisabled" : "moduleIcon",
          clickAction: "handleLocationToggle",
          title: getMessage("LOCATION"),
          userAllowed: false,
          textLabelClass: (this.props.userRole === USER_ROLES.USER) ? " cursorDisabled" : " cursorPointer",
          logo_disable: ic_location_disabled,
          logo_active: ic_location_active,
          logo_deactive: ic_location,
        };
      }
      if (modules.indexOf(Modules.SCREENSHARE) !== -1) {
        modulesInfo.SCREENSHARE = {
          logo: isAndroidOrIos() || (this.props.userRole === USER_ROLES.USER && !this.props.isPresenter) ? ic_share_disabled : ic_share,
          class: isAndroidOrIos() || (this.props.userRole === USER_ROLES.USER && !this.props.isPresenter) ? "moduleIcon cursorDisabled" : "moduleIcon",
          clickAction: isAndroidOrIos() || (this.props.userRole === USER_ROLES.USER && !this.props.isPresenter) ? "" : "handleScreenShareToggle",
          title: getMessage("SCREENSHARE"),
          userAllowed: true,
          textLabelClass: isAndroidOrIos() || (this.props.userRole === USER_ROLES.USER && !this.props.isPresenter) ? " cursorDisabled" : " cursorPointer",
          logo_disable: ic_share_disabled,
          logo_active: ic_share_active,
          logo_deactive: ic_share,
        };
      }
      if (modules.indexOf(Modules.SNAPSHOT) !== -1
        && this.props.userRole === USER_ROLES.AGENT) {
        modulesInfo.SNAPSHOT = {
          logo: this.props.customerCoBrowseStarted? ic_snapshot_disabled: ic_snapshot,
          class: this.props.customerCoBrowseStarted? "cursorDisabled moduleIcon": "moduleIcon",
          clickAction: "handleSnapshot",
          title: getMessage("SNAP_SHOT"),
          userAllowed: false,
          textLabelClass: this.props.customerCoBrowseStarted ? "cursorDisabled" : "cursorPointer",
          logo_disable: ic_snapshot_disabled,
          logo_active: ic_snapshot_active,
          logo_deactive: ic_snapshot,
        };
      }
      if (modules.indexOf(Modules.APP_EMULATION) !== -1
        && this.props.userRole === USER_ROLES.AGENT) {
        modulesInfo.APP_EMULATION = {
          logo: ic_app_emulation,
          class: window._env_.REACT_APP_ALLOW_APP_EMULATION == "true" ? "moduleIcon" : "moduleIcon cursorDisabled",
          clickAction: window._env_.REACT_APP_ALLOW_APP_EMULATION == "true" ? "handleAppEmulationToggle" : "",
          title: getMessage("APP_EMULATION"),
          userAllowed: false,
          textLabelClass: window._env_.REACT_APP_ALLOW_APP_EMULATION == "true" ? " cursorPointer" : " cursorDisabled",
          logo_disable: ic_app_emulation,
          logo_active: ic_app_emulation,
          logo_deactive: ic_app_emulation,
        };
      }
      if (modules.indexOf(Modules.CO_BROWSE) !== -1) {
        modulesInfo.CO_BROWSE = {
          logo: this.props.isPresenter ? ic_cobrowse : ic_cobrowse_disabled,
          class: this.props.isPresenter ? "moduleIcon": "moduleIcon cursorDisabled",
          clickAction: "handleTargetSiteSelectionModalToggle",
          title: getMessage("CO_BROWSE"),
          userAllowed: true,
          textLabelClass: this.props.isPresenter ? "cursorPointer" : "cursorDisabled",
          logo_disable: ic_cobrowse_disabled,
          logo_active: ic_cobrowse_active,
          logo_deactive: ic_cobrowse,
        };
      }
      if (this.props.userRole === USER_ROLES.AGENT
          && this.props.contractInfo
          && this.props.contractInfo.length > 0) {
        modulesInfo.CONTRACT_INFO = {
          logo: ic_contract_information_deactivate,
          class: "moduleIcon",
          clickAction: "toggleContractInfoModal",
          title: getMessage("CONTRACT_INFO_ICON_STRING"),
          userAllowed: true,
          textLabelClass: "cursorPointer",
          logo_deactive: ic_contract_information_deactivate,
        };
        // if contractDisplayMethid is 'AUTO',
        // Open contract info in new tab, automatically.
        this.autoOpenContractInfo()
      }
      this.props.headerAction.setHeaderIcons(modulesInfo);
    }

    if (
      this.props.showMessageToast &&
      !this.props.messagesRead &&
      isMobileOriPad()
    ) {
      this.props.showMessageArrivedToastAction(false);
      if (this.state.chatPopOver === false && this.props.isMessageArrived) {
        toastr.info(getMessage("NEW_MESSAGE"));
      }
    }

    if (this.props.locationPermissionReply == true) {
      this.props.sendWebsocketMessage(socketMessage.events.MESSAGE, {
        data: {
          category: socketMessage.category.LOCATION,
          action: socketMessage.subCategories.LOCATION.GET_ALL_LOCATION_DATA,
          sessionKey: this.props.sessionKey
        }
      });
    }
    this.props.headerAction.setIsPresenter(this.props.isPresenter);

    if (this.props.allParticipants.length > 0 && this.props.userRole === USER_ROLES.AGENT ) {
      this.showToastPreJoined()
    }

    const enableVideoBlur = this.props.enableVideoBlur ? this.props.enableVideoBlur.isEnable : false;
    if (this.props.userRole === USER_ROLES.AGENT  && enableVideoBlur) {
      this.props.headerAction.setVirtualBackground(true, FILTER_NAME.BLUR);
    }
  }

  showToastPreJoined = () => {
    const waitingParticipantsPreJoined = this.props.allParticipants.filter(
      (participant) =>
        participant.admissionStatus === USER_ADMISSION_STATUS.PENDING 
        && participant.status === PARTICIPANT_STATUS.WAITING);

    if (waitingParticipantsPreJoined.length > 0) {
      waitingParticipantsPreJoined.map((anObjectMapped, index, array) => {
        let messageKey = "ADMIT_USER";
        let message = getMessage(messageKey, { userName: anObjectMapped.userName });
        let admitToastId = TOAST_ID.ADMIT + anObjectMapped.uniqueId;
        const admitToast = {
          position: toast.POSITION.BOTTOM_RIGHT,
          transition: Slide,
          autoClose: 30000,
          hideProgressBar: false,
          closeOnClick: true,
          draggable: false,
          delay: 1000,
          toastId: admitToastId
        }
        if(!this.state.isReductionLogs){
          toast.info(<AdmitTostr
            admitParticipant = { this.admitOrRejectUserInSession }
            messageKey = { messageKey }
            message = { message }
            uniqueId = { anObjectMapped.uniqueId } />
          , admitToast)
        }
        if (array.length - 1 === index) {
          this.reloadReduction = true;
        }
      });
    }
  }

  getIframeMsg = (event) => {
    // app-emulation が投げてきたイベントが「コブラウズ終了」の場合～～
    if (event.data == 'CUSTOMER_CO_BROWSE_END_SESSION') {
      // 「共同閲覧」を終了するよう、メッセージを投げる
      postMesageToCoBrowseIframeUtility(this.props.token, this.props.coBrowseBaseUrl);
      this.state.showEndSessionConfirmationModal   = false; // プレゼンターのモーダル非表示
      this.state.showLeaveSessionConfirmationModal = false; // フォロワーのモーダル非表示
    }

    if (
      event.origin == this.props.coBrowseBaseUrl
      && event.data
      && event.data.viewAction == CUSTOMER_CO_BROWSE_ACTIONS.CO_BROWSER_END
    ) {
      // pass
    } else if (
      event.origin == this.props.coBrowseBaseUrl
      && event.data
      && event.data.viewAction == CUSTOMER_CO_BROWSE_ACTIONS.CO_BROWSER_START
      && event.data.result == CUSTOMER_CO_BROWSE_RESPONSE.START_SUCCESS
    ) {
      const message = {
        data : {
          category: socketMessage.category.CUSTOMER_CO_BROWSE,
          action: socketMessage.subCategories.CUSTOMER_CO_BROWSE.PERMISSION_REQUEST,
          sessionKey: this.props.sessionKey,
          roomId: this.props.roomId,
          shareUrl: "session?togetherjs=" + this.props.roomId,
          layoutDetails: this.props.layoutCode
        }
      };
      this.props.sendWebsocketMessage(socketMessage.events.MESSAGE, message);
    }  
    // in case load failed immediately end cobrowse session
    else if (
      event.origin == this.props.coBrowseBaseUrl
      && event.data
      && event.data.viewAction == CUSTOMER_CO_BROWSE_ACTIONS.CO_BROWSER_START
      && event.data.result == CUSTOMER_CO_BROWSE_RESPONSE.START_FAIL
    ) {
      postMesageToCoBrowseIframeUtility(this.props.endUserToken, this.props.coBrowseBaseUrl);
      const messageToWebsocket = {
        data: {
          category: socketMessage.category.CUSTOMER_CO_BROWSE,
          action: socketMessage.subCategories.CUSTOMER_CO_BROWSE.END_SESSION,
          sessionKey: this.props.sessionKey,
        }
      };
      this.props.sendWebsocketMessage(socketMessage.events.MESSAGE, messageToWebsocket);
    }
  }

  hideSideDrawer = () => {
    if (window.innerWidth > 992 && this.state.popoverOpen) {
      this.setState({ popoverOpen: false }, () => {
        if (isIE)
          document.body.style.overflow = "visible";
        else
          document.body.style.overflow = "overlay";
      })
    }
  }

  getBaseUrl = () => {
    let baseUrl = window.location.origin;
    if (baseUrl) {
      baseUrl =
        baseUrl + (this.props.customerUriIdentifier
          ? '/' + this.props.customerUriIdentifier : '') + "/join?sessionKey=" + this.props.sessionKey + "&openExternalBrowser=1";
      this.setState({ sessionLink: baseUrl });
    } else {
      baseUrl =
        window.location.protocol +
        "//" +
        window.location.hostname +
        (window.location.port ? ":" + window.location.port : "");
      baseUrl =
        baseUrl + (this.props.customerUriIdentifier
          ? '/' + this.props.customerUriIdentifier
          : '') + "/join?sessionKey=" + this.props.sessionKey;
      this.setState({ sessionLink: baseUrl });
    }
  };

  static getDerivedStateFromProps(props, state) {
    if (props.organiser === props.uniqueId) {
      if (props.snapshotPermissionReply === false) {
        // for participant - show toast msg for plugin not installed status for snapshot extracted from snapshotPermissionStatus
        let snapshoteeParticipant = props.admittedParticipants.filter(admittedParticipant => admittedParticipant.uniqueId === props.snapshoteeId)[0];
        if (snapshoteeParticipant) {
          if (!props.snapshotPermissionStatus.isPluginInstalled) {
            toastr.error(getMessage("USER_DONT_HAVE_PLUGIN", { userName: snapshoteeParticipant.userName }),
              {
                onClose: () =>
                  props.headerAction.clearSnapshotPermissionReplyStatus()
              })
          } else if (!props.snapshotPermissionStatus.isUserWebCamPresent) { //user doesn't have camera
            toastr.error(getMessage("USER_DONT_HAVE_CAMERA", { userName: snapshoteeParticipant.userName }),
              {
                toastId: props.snapshoteeId //to avoid dublication 
              }
            );
          } else { // user have camera and rejected request
            toastr.info(getMessage("DENIED_SNAPSHOT_PERMISSION", { userName: snapshoteeParticipant.userName }), 
              {
                toastId: props.snapshoteeId //to avoid dublication 
              }
            );
          }
        }
      }
    }
    if (
      props.locationPermissionReply === true &&
      !state.locationPopOver
    ) {
      return { locationPopOver: true };
    } else if (
      props.locationPermissionReply !== true &&
      state.locationPopOver
    ) {
      return { locationPopOver: false };
    }
    if (props.isSnapshotTaken === false) {
      toastr.info(`${getMessage("SNAPSHOT_NOT_TAKEN")}`);
      if (props.admittedParticipants.length <= 2) {
        props.headerAction.setShowSnapshot(false);
      }
      props.headerAction.setIsSnapshotTaken(null);
    } else if (props.isSnapshotTaken === true) {
      toastr.info(`${getMessage("SNAPSHOT_TAKEN")}`);
      props.headerAction.setIsSnapshotTaken(null);
    }

    if (
      props.webRtcPermissionReplyStatus !== null &&
      props.webRtcPermissionReplyStatus.isGranted &&
      (!props.webRtcPermissionReplyStatus.isMicConnected
        || !props.webRtcPermissionReplyStatus.isCameraConnected)
    ) {
      const toastrOptions = {
        toastId: "CameraNotConnectedToastId",
        onClose: () =>
          props.headerAction.clearWebRtcPermissionReplyStatus()
      };

      for (let i = 0; i < props.admittedParticipants.length; i++) {
        if (props.admittedParticipants[i].uniqueId !== props.organiser) {
          if (
            props.webRtcPermissionReplyStatus.uniqueId ===
            props.admittedParticipants[i].uniqueId
          ) {
            if (!props.webRtcPermissionReplyStatus.isCameraConnected) {
              toastr.error(getMessage("USER_DONT_HAVE_CAMERA", { userName: props.admittedParticipants[i].userName }), toastrOptions)
            }
            if (!props.webRtcPermissionReplyStatus.isMicConnected) {
              toastr.error(getMessage("USER_DONT_HAVE_MIC", { userName: props.admittedParticipants[i].userName }), toastrOptions)
            }
          }
        }
      }
    }

    if (props.sessionStatus != SESSION_STATUS.CLOSING && props.isMessageArrived && !props.messagesRead) {
      if (state.chatPopOver === false && props.isMessageArrived) {
        let modulesInfo = props.headerIcons;
        if (modulesInfo[Modules.CHAT]) {
          modulesInfo[Modules.CHAT].class = "moduleIconActive";
          modulesInfo[Modules.CHAT].logo = modulesInfo[Modules.CHAT].logo_active;
        }
        props.headerAction.setHeaderIcons(modulesInfo);
        return {
          isMessageArrived: props.isMessageArrived,
          chatPopOver: !state.chatPopOver
          // ... other derived state properties
        };
      } else return null;
    } else {
      return null;
    }
  }

  getPresenterName = uniqueId => {
    let userNames = this.props.admittedParticipants.filter(
      participant => participant.uniqueId === uniqueId
    )[0];
    if (userNames) {
      return userNames.userName;
    } else {
      return false;
    }
  };

  sortParticipantToAcronym = () => {
    let participantList = [];
    if (this.props.allParticipants) {
      _.map(this.props.allParticipants, participantObject => {
        // sorting done for participants 
        // organiser, presenter, self and then others
        if (participantObject.role === USER_ROLES.AGENT) {
          participantList.splice(0, 0, participantObject);
        } else {
          if (this.props.presenter === participantObject.uniqueId) {
            participantList.splice(1, 0, participantObject);
          } else if (participantObject.uniqueId === this.props.uniqueId) {
            if (participantList[1] && participantList[1].uniqueId == this.props.presenter) {
              participantList.splice(2, 0, participantObject);
            } else {
              participantList.splice(1, 0, participantObject);
            }
          } else {
            participantList.push(participantObject);
          }
        }
      })
      this.setState({ sortedParticipants: participantList })
    } else {
      this.setState({ sortedParticipants: this.props.allParticipants })
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if(prevProps.customerCoBrowseStarted !== this.props.customerCoBrowseStarted) {   
      let modulesInfo = { ...this.props.headerIcons }

      //disable snapshot icon cobrowse running
      if (modulesInfo["SNAPSHOT"]) {
        modulesInfo["SNAPSHOT"] = {
          ...modulesInfo["SNAPSHOT"],
          logo: this.props.customerCoBrowseStarted? ic_snapshot_disabled: ic_snapshot,
          class: this.props.customerCoBrowseStarted? "cursorDisabled moduleIcon": "moduleIcon cursorPointer",
          textLabelClass: this.props.customerCoBrowseStarted? "cursorDisabled": "cursorPointer",
        };
      }     
      this.props.headerAction.setHeaderIcons(modulesInfo);

      //set cobrowse icon to active and click disable 
      if(this.props.customerCoBrowseStarted) {    
        this.props.headerAction.updateHeaderIconClass(
          Modules.CO_BROWSE,
          "moduleIconActive cursorDisabled",
          "cursorDisabled"
        );
      } else {
        if(this.props.isPresenter) {
          this.props.headerAction.updateHeaderIconClass(
            Modules.CO_BROWSE,
            "moduleIcon cursorPointer",
            "cursorPointer"
          );
        } else {
          this.props.headerAction.updateHeaderIconClass(
            Modules.CO_BROWSE,
            "moduleIcon cursorDisabled",
            "cursorDisabled"
          );
        }
      }
    }

    if (prevProps.isPresenter !== this.props.isPresenter) {
      this.props.headerAction.setIsPresenter(this.props.isPresenter);
    }

    if((prevProps.showSnapshot !== this.props.showSnapshot || 
      prevProps.snapshotPermissionReply !== this.props.snapshotPermissionReply ||
      prevProps.isSnapshotRunning !== this.props.isSnapshotRunning)) { 
      let modulesInfo = { ...this.props.headerIcons }
      //set cobrowse icon to active and click disable for presenter only
      if (modulesInfo["CO_BROWSE"]) {
        modulesInfo["CO_BROWSE"] = {
          ...modulesInfo["CO_BROWSE"],
          logo: this.props.isPresenter && !this.isSnapshotStarted() ? ic_cobrowse: ic_cobrowse_disabled,
          class: this.props.isPresenter && !this.isSnapshotStarted() ? "moduleIcon" : "moduleIcon cursorDisabled",
          textLabelClass: this.props.isPresenter && !this.isSnapshotStarted() ? "cursorPointer" : "cursorDisabled",
          clickAction: this.props.isPresenter && "handleTargetSiteSelectionModalToggle"
        };
      }
      this.props.headerAction.setHeaderIcons(modulesInfo);
    }

    // for participant - show toast msg for plugin not installed status only for screenshare
    if (this.props.organiser === this.props.uniqueId &&
      this.props.pluginNotInstalledParticipantIds !== prevProps.pluginNotInstalledParticipantIds &&
      this.props.pluginNotInstalledParticipantIds) {
      for (let i = 0; i < this.props.admittedParticipants.length; i++) {
        if (this.props.pluginNotInstalledParticipantIds.indexOf(this.props.admittedParticipants[i].uniqueId) != -1) {
          toastr.error(getMessage("USER_DONT_HAVE_PLUGIN",
            { userName: this.props.admittedParticipants[i].userName }));
        }
      }
    }

    if (this.props.locationPermissionReply !== prevProps.locationPermissionReply
      && this.props.locationPermissionReply === true
      && this.props.uniqueId != this.props.organiser) { // need to process only for user as organiser is already processing it in _SHARE_LOCATION WS call
      this.props.sendWebsocketMessage(socketMessage.events.MESSAGE, {
        data: {
          category: socketMessage.category.LOCATION,
          action: socketMessage.subCategories.LOCATION.GET_ALL_LOCATION_DATA,
          sessionKey: this.props.sessionKey
        }
      });
    }

    //cursor disable for the co-browser when cobrowser is running
    if (prevProps.showCoBrowse !== this.props.showCoBrowse && this.props.isPresenter) {
      if (this.props.showCoBrowse) {
        this.props.headerAction.updateHeaderIconClass("CO_BROWSE", "moduleIconActive cursorDisabled", " cursorDisabled")
      } else {
        this.props.headerAction.updateHeaderIconClass("CO_BROWSE", "moduleIcon cursorPointer", " cursorPointer")
      }
    }

    // Notify user on edit permission change
    if (this.props.uniqueId !== this.props.organiser && !_.isEqual(this.props.admittedParticipants, prevProps.admittedParticipants)) {
      let index = _.findIndex(prevProps.admittedParticipants,
        participant => participant && participant.uniqueId === this.props.uniqueId);
      let prevParticipant = index && index !== -1 ? prevProps.admittedParticipants[index] : null;

      let participantIndex = _.findIndex(this.props.admittedParticipants,
        participant => participant && participant.uniqueId === this.props.uniqueId);
      let participant = participantIndex && participantIndex !== -1 ? this.props.admittedParticipants[participantIndex] : null;

      if (prevParticipant && participant && prevParticipant.allowEditAccess !== participant.allowEditAccess) {
        if (participant.allowEditAccess) {
          if (this.state.disableCanvasEdit) {
            toastr.info(`${getMessage("USER_ALLOWED_TO_EDIT_PDF")} `);
          } else {
            toastr.info(`${getMessage("USER_ALLOWED_TO_EDIT_CANVAS_PDF")} `);
          }
        } else {
          toastr.info(`${getMessage("REVOKING_EDIT_PERMISSION")} `);
        }
      }
    }

    //denied audio and video permission
    if (
      this.props.webRtcPermissionReplyStatus !== null &&
      !this.props.webRtcPermissionReplyStatus.isGranted &&
      this.props.webRtcPermissionReplyStatus.uniqueId !==
      prevProps.webRtcPermissionReplyStatus?.uniqueId
    ) {
      const toastrOptions = {
        toastId: "audioCallDeniedToastId",
        onClose: () =>
          this.props.headerAction.clearWebRtcPermissionReplyStatus()
      };
      let permissionRepliedPrticipant = this.props.admittedParticipants.filter(admittedParticipant => admittedParticipant.uniqueId === this.props.webRtcPermissionReplyStatus.uniqueId)[0];
      if (permissionRepliedPrticipant.uniqueId !== this.props.organiser) {
        if (this.props.webRtcPermissionReplyStatus.isMicConnected &&
          this.props.webRtcPermissionReplyStatus.isCameraConnected &&
          this.props.webRtcPermissionReplyStatus.isPluginInstalled
        ) {
          toastr.info(this.props.webRtcPermissionReplyStatus.media === mediaType.AUDIO
            ? getMessage(
              "DENIED_AUDIO_PERMISSION",
              { userName: permissionRepliedPrticipant.userName }
            )
            : this.props.webRtcPermissionReplyStatus.media ===
              mediaType.AUDIO_VIDEO
              ? getMessage(
                "DENIED_VIDEO_PERMISSION",
                { userName: permissionRepliedPrticipant.userName }
              )
              : ""
          ,
          toastrOptions
          );
        } else {
          if (!this.props.webRtcPermissionReplyStatus.isCameraConnected) {
            toastr.error(getMessage("USER_DONT_HAVE_CAMERA", { userName: permissionRepliedPrticipant.userName }), toastrOptions)
          }
          if (!this.props.webRtcPermissionReplyStatus.isMicConnected) {
            toastr.error(getMessage("USER_DONT_HAVE_MIC", { userName: permissionRepliedPrticipant.userName }), toastrOptions)
          }
        }
      }
    }

    //location permision denied handle
    if (
      this.props.locationPermissionReplyStatus !== null &&
      !this.props.locationPermissionReplyStatus.isGranted &&
      this.props.locationPermissionReplyStatus.uniqueId !==
      prevProps.locationPermissionReplyStatus?.uniqueId
    ) {
      const toastrOptions = {
        onClose: () =>
          this.props.headerAction.clearLocationPermissionReplyStatus()
      };

      for (let i = 0; i < this.props.admittedParticipants.length; i++) {
        if (this.props.admittedParticipants[i].uniqueId !== this.props.organiser) {
          if (
            this.props.locationPermissionReplyStatus.uniqueId ===
            this.props.admittedParticipants[i].uniqueId && this.props.userRole === USER_ROLES.AGENT
          )
            toastr.info(
              getMessage(
                "DENIED_LOCATION_PERMISSION",
                { userName: this.props.admittedParticipants[i].userName }
              ),
              toastrOptions
            );
        }
      }
    }

    // send webrtc request after pipeline is created 
    // ie. after SHARE_WEBRTC_MEDIA
    if (this.props.callMediaType !== prevProps.callMediaType &&
      this.props.callMediaType) {
      if (this.props.uniqueId === this.props.organiser) {
        this.sendCallRequestForMedia(this.props.callMediaType)
      }
      this.props.headerAction.setCallMediaType(null)
    }

    // show msg to user when screen share starts
    if (document.getElementById(Modules.SCREENSHARE)) {
      document.getElementById(Modules.SCREENSHARE).className = this.props.isPresenter
        ? this.props.headerIcons[Modules.SCREENSHARE].class
        : this.props.headerIcons[Modules.SCREENSHARE].class + " cursorDisabled";
    }

    if (isMobileOriPad() && this.props.screenSharingParticipantId !== prevProps.screenSharingParticipantId && this.props.screenSharingParticipantId) {
      toastr.info(`${getMessage("SCREEN_SHARE_STARTED")} `);
    }

    if (this.props.sessionStatus !== prevProps.sessionStatus && this.props.sessionStatus === SESSION_STATUS.CLOSING && this.state.chatPopOver) {
      this.setState({ chatPopOver: false })
    }

    if (prevProps.isCallEnded !== this.props.isCallEnded && this.props.isCallEnded && this.props.organiser !== this.props.uniqueId) {
      toastr.info(getMessage("AGENT_ENDED_CALL"))
    }

    if (prevProps.presenter !== this.props.presenter) {
      let presenterName = this.getPresenterName(this.props.presenter);
      if (presenterName) {
        if (this.props.uniqueId !== this.props.presenter) {
          if (this.props.organiser === this.props.presenter) {
            presenterName = getUserNameForSelectedLanguage(this.props.language, presenterName);
          }
          toastr.info(`${presenterName} ${getMessage("PRESENTER_CHANGED")} `);
        } else {
          toastr.info(`${getMessage("YOU_ARE_PRESENTER")} `);
        }
      }
      this.sortParticipantToAcronym();

      let modulesInfo = { ...this.props.headerIcons }
      // change screenshare disable enable icon based on presenter
      if (!isMobileOriPad()) {
        if (modulesInfo["SCREENSHARE"]) {
          modulesInfo["SCREENSHARE"] = {
            ...modulesInfo["SCREENSHARE"],
            logo: this.props.isPresenter ? ic_share : ic_share_disabled,
            class: this.props.isPresenter ? "moduleIcon " : "moduleIcon cursorDisabled",
            textLabelClass: this.props.isPresenter ? " cursorPointer" : " cursorDisabled",
            clickAction: this.props.isPresenter ? "handleScreenShareToggle" : ""
          };
        }
      }

      // change co-browse disable enable icon based on presenter
      if (modulesInfo["CO_BROWSE"]) {
        modulesInfo["CO_BROWSE"] = {
          ...modulesInfo["CO_BROWSE"],
          logo: this.props.isPresenter && !this.isSnapshotStarted() ? ic_cobrowse : ic_cobrowse_disabled,
          class: this.props.isPresenter && !this.isSnapshotStarted() ? "moduleIcon" : "moduleIcon cursorDisabled",
          textLabelClass: this.props.isPresenter && !this.isSnapshotStarted() ? "cursorPointer" : "cursorDisabled",
          clickAction: this.props.isPresenter ? "handleTargetSiteSelectionModalToggle" : ""
        };
      }
      this.props.headerAction.setHeaderIcons(modulesInfo);
    }
    if (
      this.props.showMessageToast &&
      !this.props.messagesRead &&
      isMobileOriPad()
    ) {
      this.props.showMessageArrivedToastAction(false);
      if (this.state.chatPopOver === false && this.props.isMessageArrived) {
        toastr.info(getMessage("NEW_MESSAGE"));
      }
    }

    if (this.props.organiser !== this.props.uniqueId &&
      this.props.uniqueId &&
      this.props.isSessionEnded) {
      this.props.setSpinnerVisibility(false)
      this.props.history.push(CONFIG.path.sessionEnded);
    } else if ((this.props.organiser == this.props.uniqueId ||
      this.props.userRole === USER_ROLES.AGENT) &&
      this.props.sessionType !== "SUPPORT_CENTER" &&
      this.props.isSessionEnded) {
      leaveSessionAction.localSessionAllDataCleanUp();
      this.props.setSpinnerVisibility(false)
      if (this.props.isDisabledMenu) {
        this.props.history.push(CONFIG.path.sessionEndScreen);
      } else {
        this.props.history.push(CONFIG.path.createSession);
      }
    } else if (this.props.userRole === USER_ROLES.AGENT &&
      this.props.sessionType === "SUPPORT_CENTER" &&
      this.props.isSessionEnded) {
      // After the support center session ends,
      // the operator will be redirected to the callWaiting page.
      leaveSessionAction.localSessionAllDataCleanUp();
      this.props.setSpinnerVisibility(false)
      this.props.history.push(CONFIG.path.callWaiting);
    }

    if (this.props.latestUpdatedParticipant) {
      const prevParticipantCount = prevProps.allParticipants.length;
      const currParticipantCount = this.props.allParticipants.length;

      const { userName, uniqueId, admissionStatus } = this.props.latestUpdatedParticipant;

      if (this.props.allParticipants.length > 0 && this.props.userRole === USER_ROLES.AGENT && this.reloadReduction === false) {
        this.showToastPreJoined()

      }

      if (prevParticipantCount < currParticipantCount) {

        if (this.props.uniqueId !== uniqueId) {
          if (admissionStatus == USER_ADMISSION_STATUS.ADMITTED) {
            toastr.info(getMessage("ARRIVED", { userName: userName }), {
              toastId: "UserArrivedToastId" //to avoid dublication
            });
          } else {
            let messageKey = "ADMIT_USER";
            let message = getMessage(messageKey, { userName: userName });
            let admitToastId = TOAST_ID.ADMIT + uniqueId;
            const admitToast = {
              position: toast.POSITION.BOTTOM_RIGHT,
              transition: Slide,
              autoClose: 30000,
              hideProgressBar: false,
              closeOnClick: true,
              draggable: false,
              delay: 1000,
              toastId: admitToastId
            }
            if(!this.state.isReductionLogs){
              toast.info(<AdmitTostr
                admitParticipant = { this.admitOrRejectUserInSession }
                messageKey = { messageKey }
                message = { message }
                uniqueId = { uniqueId } />
              , admitToast)
            }
          }
        }
      } else if (prevParticipantCount > currParticipantCount) {
        //close wating area popup when agent left the loby 
        if (this.props.latestUpdatedParticipant?.role === "AGENT")
          this.setState({ showWaitingArea: false })

        if (this.props.frameLockedParticipantId == uniqueId)
          this.removeActiveFrame();

        if (this.props.organiser === this.props.uniqueId && admissionStatus == USER_ADMISSION_STATUS.REJECTED) {
          toastr.info(getMessage("DISMISSED", { userName: userName }));
        }

        if (admissionStatus == USER_ADMISSION_STATUS.ADMITTED) {
          if(uniqueId !== this.props.evictedParticipantDetails.uniqueId) {
            toastr.info(getMessage("LEFT", { userName: userName }));
          }
        }
      }
    }

    /*
    if (prevProps.participantJoinedUniqueId !== this.props.participantJoinedUniqueId && this.props.participantJoinedUniqueId) {
      let leftParticipantobject = _.find(this.props.admittedParticipants, { uniqueId: this.props.participantJoinedUniqueId })
      if (leftParticipantobject) {
        toastr.info(getMessage("JOINED_APP_EMULATION_SESSION", leftParticipantobject));
      }
    }
    */
    if (prevProps.participantLeftUniqueId !== this.props.participantLeftUniqueId && this.props.participantLeftUniqueId) {
      let leftParticipantobject = _.find(this.props.admittedParticipants, { uniqueId: this.props.participantLeftUniqueId })
      if (leftParticipantobject) {
        toastr.info(getMessage("LEFT_APP_EMULATION_SESSION", leftParticipantobject));
      }
    }
    if (prevProps.appEmulationIsSessionEnded !== this.props.appEmulationIsSessionEnded && this.props.appEmulationIsSessionEnded) {

      toastr.info(getMessage("AGENT_HAD_CLOSE_APP_EMULATION"));
    }

    if (prevProps.participantDeniedUniqueId !== this.props.participantDeniedUniqueId && this.props.participantDeniedUniqueId) {
      let deniedParticipantobject = _.find(this.props.admittedParticipants, { uniqueId: this.props.participantDeniedUniqueId })
      if (deniedParticipantobject) {
        toastr.info(getMessage("APP_EMULATION_PERMISSION_DENIED", deniedParticipantobject));
      }
    }

    if (!_.isEqual(this.props.allParticipants, prevProps.allParticipants)) {
      this.sortParticipantToAcronym();
    }

    if (this.props.showKmsConnectionStatus && !this.props.kmsConnectionStatus) {
      toastr.error(getMessage("KMS_NOT_CONNECTED"));
      this.props.sessionActions.resetShowKmsConnectionStatusAction();
      this.hideSpinner();
    }

    if (this.props.webRtcPermissionRequest !== prevProps.webRtcPermissionRequest && this.props.uniqueId === this.props.organiser) {
      let modulesInfo = { ...this.props.headerIcons }
      modulesInfo["AUDIO"] = {
        ...modulesInfo["AUDIO"],
        logo: (this.props.userRole === USER_ROLES.USER || this.props.webRtcPermissionRequest === Modules.AUDIO_VIDEO) ? ic_audio_disabled : ic_audio,
        class: (this.props.userRole === USER_ROLES.USER || this.props.webRtcPermissionRequest === Modules.AUDIO_VIDEO) ? "moduleIcon cursorDisabled" : "moduleIcon",
        textLabelClass: (this.props.userRole === USER_ROLES.USER || this.props.webRtcPermissionRequest === Modules.AUDIO_VIDEO) ? " cursorDisabled" : " cursorPointer",
      };
      this.props.headerAction.setHeaderIcons(modulesInfo);
    }
    if (prevProps.isCameraBusy !== this.props.isCameraBusy && this.props.isCameraBusy && this.props.uniqueId === this.props.organiser) {
      //Is user block camera access (agent side Check)
      toastr.error(getMessage("USER_CAMERA_BUSY"));
      this.props.headerAction.setSnapshotCameraPermissionflag(null);
      this.props.headerAction.setCameraBusyFlag(null);
    }
    if (prevProps.isCameraPermissionGranted !== this.props.isCameraPermissionGranted && this.props.isCameraPermissionGranted === false && this.props.uniqueId === this.props.organiser) {
      //Is user block camera access (agent side Check)
      toastr.error(getMessage("USER_BLOCK_CAMERA_ACCESS"));
      this.props.headerAction.setSnapshotCameraPermissionflag(null);
    }

    if (
      this.props.snapshotPermissionReply && this.props.snapshotPermissionReply != prevProps.snapshotPermissionReply
    ) {
      this.setState({
        isSnapshotPermissionButtonClicked: false,
        spinnerVisibility: false,
        isDeviceAttached: null
      });
    }

    // participant joined the co-browse session
    if (prevProps.coBrowseJoinedParticipantUniqueId !== this.props.coBrowseJoinedParticipantUniqueId
      && this.props.coBrowseJoinedParticipantUniqueId) {
      let joinedParticipant = _.find(this.props.admittedParticipants, { uniqueId: this.props.coBrowseJoinedParticipantUniqueId });
      if (joinedParticipant) {
        toastr.info(getMessage("JOINED_CO_BROWSE_SESSION", joinedParticipant));
      }
    }

    //participant left co-browse session and is not user himself
    if (prevProps.participantLeftCoBrowseUniqueId !== this.props.participantLeftCoBrowseUniqueId &&
      this.props.participantLeftCoBrowseUniqueId &&
      this.props.uniqueId !== this.props.participantLeftCoBrowseUniqueId) {
      let leftParticipant = _.find(this.props.admittedParticipants, { uniqueId: this.props.participantLeftCoBrowseUniqueId })
      if (leftParticipant) {
        toastr.info(getMessage("LEFT_CO_BROWSE", leftParticipant));
      }
    }

    // participant denied co-browse permission
    if (prevProps.participantDeniedCoBrowseUniqueId !== this.props.participantDeniedCoBrowseUniqueId
      && this.props.participantDeniedCoBrowseUniqueId) {
      let deniedParticipant = _.find(this.props.admittedParticipants, { uniqueId: this.props.participantDeniedCoBrowseUniqueId })
      if (deniedParticipant) {
        toastr.info(getMessage("CO_BROWSE_PERMISSION_DENIED", deniedParticipant));
      }
    }
    //If Cb session ended , page is reloaded
    if (prevProps.showCustomerCoBrowse !== this.props.showCustomerCoBrowse
       && !this.props.showCustomerCoBrowse && !prevProps.endCustomerCBSession) {
      toastr.info(getMessage("CO_BROWSE_ENDED"))
    }
    // Show toastr agent and other users, if any user is evicted from the session.
    let evictedParticipantName = this.props.evictedParticipantDetails.evictedParticipantName;
    if(prevProps.evictedParticipantDetails.uniqueId !== this.props.evictedParticipantDetails.uniqueId) {
      if(this.props.uniqueId === this.props.organiser) {
        toastr.info(`${evictedParticipantName} ${getMessage("USER_EVICTED")} `);
      } else {
        toastr.info(`${evictedParticipantName} ${getMessage("LEFT")} `);
      } 
    }
    if(this.props.isUserEvicted === true && prevProps.isUserEvicted !== this.props.isUserEvicted) {
      this.props.history.push(
        {pathname: CONFIG.path.userEvicted, state: { userSessionName: this.props.userSessionName}}
      );
    }
    // If presenter has changed, and user was the previous presenter then post end_without_confirmation message to iframe 
    // This is when we change presenter from waiting area
    if (this.props.presenter !== prevProps.presenter && prevProps.presenter == this.props.uniqueId && this.props.showCustomerCoBrowse && !this.props.endCustomerCBSession) {
      console.log("End_session_without_confirmation on presenter change")
      postMesageToCoBrowseIframeUtility(this.props.endUserToken, this.props.coBrowseBaseUrl);
      const messageToWebsocket = {
        data: {
          category: socketMessage.category.CUSTOMER_CO_BROWSE,
          action: socketMessage.subCategories.CUSTOMER_CO_BROWSE.END_SESSION,
          sessionKey: this.props.sessionKey,
        }
      };
      this.props.sendWebsocketMessage(socketMessage.events.MESSAGE, messageToWebsocket);
    }
    if (prevProps.showPreviewModal != this.props.showPreviewModal) {
      if (this.props.isEnableShowPreview && this.props.showPreviewModal) {
        this.showSpinner();
        navigator.mediaDevices.getUserMedia({video: true, audio: true})
        .then(stream => {
          stream && stream.getTracks().forEach(track => {
            track.stop();
          });
        })
        .finally(() => {
          this.setState({showPreviewModal: true});
          this.hideSpinner();
        });
      } else { 
        this.setState({showPreviewModal: false});
      }
    }
    if(this.state.isReductionLogs){
      if (this.props.customerCoBrowsePermissionRequest && !prevProps.customerCoBrowsePermissionRequest &&
        this.props.customerCoBrowsePermissionReply === null) {
        if (this.props.presenter !== this.props.uniqueId) {
          this.handleCustomerCoBrowseYesClick();
        }
      }
      if (
        !this.state.locationPopOver &&
        this.props.locationPermissionReply === null &&
        ( ( this.props.isLocation && !prevProps.isLocation ) || (this.props.isLocationSharing && !prevProps.isLocationSharing) ) && 
        this.props.organiser !== this.props.uniqueId
      ) {
        this.handleLocationYesClick();
      }
      
      if ( !isSafari) {
        if (
          this.props.organiser !== this.props.uniqueId &&
          this.props.snapshoteeId && !prevProps.snapshoteeId &&
          this.props.uniqueId &&
          this.props.snapshoteeId === this.props.uniqueId &&
          this.props.snapshotPermissionReply === null
        ) {
          this.handleSnapshotYesClick();
        }
        if (!this.state.isButtonClicked && 
          ( ( this.props.webRtcPermissionRequest !== null && prevProps.webRtcPermissionRequest === null ) ||
            ( this.props.webRtcPermissionRequest !== null && this.props.webRtcPermissionRequest !== prevProps.webRtcPermissionRequest ) ) &&
          this.props.webRtcPermissionReply === null &&
          this.props.organiser !== this.props.uniqueId ||
          (this.props.isSessionEnded && this.props.organiser === this.props.uniqueId)) {
          this.checkDevicesAreConnectOrNot();
        }
      }
    }
  }

  isSnapshotStarted =()=> {
    return (this.props.showSnapshot || 
      (this.props.snapshoteeId && this.props.snapshotPermissionReply) ||
      this.props.isSnapshotRunning)
  }

  handleEndSession = () => {
    toast.dismiss();
    this.props.handleEndSession();
  };

  handleCancelClick = () => {
    this.setState({ popoverOpen: false }, () => {
      if (isIE)
        document.body.style.overflow = "visible";
      else
        document.body.style.overflow = "overlay";
    });
  };

  renderSprinner() {
    return <Spinner showSpinner={this.state.spinnerVisibility} />;
  }

  showSpinner = () => {
    this.setState({
      spinnerVisibility: true
    });
  };

  hideSpinner = () => {
    this.setState({
      spinnerVisibility: false
    });
  };

  handleModuleClick = module => {
    this.setState({ popoverOpen: false }, () => {
      if (isIE)
        document.body.style.overflow = "visible";
      else
        document.body.style.overflow = "overlay";
    });
    let modulesInfo = this.props.headerIcons;

    if (
      modulesInfo[module].class === "moduleIconActive" &&
      module !== Modules.CHAT
    )
      return;
    if (
      this.props.headerIcons[module] &&
      this.props.headerIcons[module].class === "moduleIconActiveHidden"
    ) {
      this.props.headerAction.updateHeaderIconClass(module, "moduleIconActive", " cursorPointer");
      document.getElementById("AudioVideoContainer").style.display = "block";
      return;
    }
    const method = this.headerIconClickActions[modulesInfo[module].clickAction];
    const userAllowed = modulesInfo[module].userAllowed;
    /**(this.props.userRole === USER_ROLES.AGENT ||
        (this.props.userRole !== USER_ROLES.AGENT && userAllowed)) */
    if (
      typeof method === "function" &&
      (this.props.organiser === this.props.uniqueId ||
        (this.props.organiser !== this.props.uniqueId && userAllowed))
    ) {
      method();
    }

  };

  handleTargetSiteSelectionModalToggle = (showTargetSiteSelectionModal) => {
    if(this.isSnapshotStarted()){
      toastr.error(getMessage("CUSTOMER_CO_BROWSE_CANNOT_USE_WITH_SNAPSHOT"),
        {toastId: "CUSTOMER_CO_BROWSE_CANNOT_USE_WITH_SNAPSHOT"})
      return
    }
    if (showTargetSiteSelectionModal && (!this.checkParticipantsAvailable() ||
    this.props.showCustomerCoBrowse)) return;
    customerCoBrowseAction.showTargetSiteSelectionModalAction(showTargetSiteSelectionModal)
  }

  handleAudioToggle = async () => {
    let webRtcMediaTypeToBeShared = this.props.webRtcPermissionRequest;
    if (webRtcMediaTypeToBeShared !== null) return;
    if (!isWebRTCPluginInstalled()) return;       // for self - check and show toast msg for plugin uninstalled
    this.props.headerAction.resetParticipantsPluginInfo();
    //if (!this.checkKMSStatus()) return
    let audioDevices = [];
    this.showSpinner();
    await navigator.mediaDevices.enumerateDevices().then(devices => {
      console.log('[handleAudioToggle] devices list: ', devices);
      audioDevices = devices.filter(device => {
        if (device.kind === "audioinput") {
          return true;
        }
      });
    });
    if(audioDevices.length <= 0) {
      toastr.error(getMessage("MIC_NOT_CONNECTED"));
      this.hideSpinner();
    } else {
      // call getUserMedia to check if audio device is available / not busy
      // call getUserMedia to fix WAAG-4944 because safari only gets default devices until after getUserMedia is called.
      navigator.mediaDevices.getUserMedia({ audio: true })  // getUserMedia will fail if audio is busy / unavailable
      .then(stream => {
        this.stopMediaTracksOfGivenStream(stream);  // stop streams retrieved as Video component will retrieve it
        // send share media request
        this.sendShareMediaRequest(mediaType.AUDIO);
      })
      .catch((error) => {
        const errorMessage = getUserMediaError(error, mediaType.AUDIO);
        if (errorMessage) {
          toastr.error(getMessage(errorMessage))
        }
        this.hideSpinner();
      });
    }
  };

  handleAudioVideoToggle = async (audioStatus = mediaStatus.UNMUTED, videoStatus = mediaStatus.UNMUTED) => {
    // if camera is busy already
    if (this.props.webRtcPermissionRequest == mediaType.AUDIO_VIDEO) return;
    if (!isWebRTCPluginInstalled()) return;    // for self - check and show toast msg for plugin uninstalled
    this.props.headerAction.resetParticipantsPluginInfo();
    //if (!this.checkKMSStatus()) return;
    this.checkCameraAndSendVideoCallRequest(audioStatus, videoStatus);
  }

  checkCameraAndSendVideoCallRequest = async (audioStatus, videoStatus) => {
    this.showSpinner();
    let audioCheckOK = true;
    let audioDevices = [];
    let videoDevices = [];    
    await navigator.mediaDevices.enumerateDevices().then(devices => {
      audioDevices = devices.filter(device => {
        if (device.kind === "audioinput") {
          return true;
        }
      });
      videoDevices = devices.filter(device => {
        if (device.kind === "videoinput") {
          return true;
        }
      });
    });
    
    if(audioDevices.length <= 0) {
      toastr.error(getMessage("MIC_NOT_CONNECTED"));
      audioCheckOK = false;
    } else {
      let constraintsSettings = {
        media: mediaType.AUDIO,
      };
      if(!isMobileOriPad()) {
        constraintsSettings.audioDeviceId = this.props.audioDeviceId;
      }
      const constraints = getMediaConstraints(constraintsSettings);
      navigator.mediaDevices.getUserMedia(constraints)
      .then(stream => {
        this.stopMediaTracksOfGivenStream(stream);
      })
      .catch((error) => {
        const errorMessage = getUserMediaError(error, mediaType.AUDIO);
        if (errorMessage) {
          toastr.error(getMessage(errorMessage));
        }
        audioCheckOK = false;
      });
    }

    if (videoDevices.length <= 0) {
      // if camera is not found with Agent, no need to check camera busy so send share media req
      // Agent will join with mike only and user may join with camera and mike if he has
      toastr.error(getMessage("WEBCAM_NOT_CONNECTED"));
      if (audioCheckOK) {
        this.sendShareMediaRequest(mediaType.AUDIO_VIDEO, audioStatus, videoStatus);
      } else {
        this.hideSpinner();
      }
    } else {
      // call getUserMedia to check if camera is available / not busy
      // call getUserMedia because safari only gets default devices until after getUserMedia is called,
      // due to which stream is not displayed when we start call first time from a tab
      let constraintsSettings = {
        media: mediaType.VIDEO,
      };
      if(isMobileOriPad()) {
        constraintsSettings.facingMode = this.props.facingMode;
      } else {
        constraintsSettings.videoDeviceId = this.props.videoDeviceId;
      }
      const constraints = getMediaConstraints(constraintsSettings);
      navigator.mediaDevices.getUserMedia(constraints)  // getUserMedia will fail if camera is busy / unavailable
      .then(stream => {
        this.stopMediaTracksOfGivenStream(stream);  // stop streams retrieved as Video component will retrieve it
        if (audioCheckOK) {
          // send share media request
          this.sendShareMediaRequest(mediaType.AUDIO_VIDEO, audioStatus, videoStatus);
        } else {
          this.hideSpinner();
        }
      }).catch((error) => {
        let errorMessage = getUserMediaError(error, mediaType.VIDEO);
        if (errorMessage) {
          toastr.error(getMessage(errorMessage))
        }
        this.hideSpinner();
      });
    }
  }

  sendShareMediaRequest = (requestMediaType, audioStatus = mediaStatus.UNMUTED, videoStatus = mediaStatus.UNMUTED) => {
    navigator.mediaDevices.enumerateDevices().then(devices => {
      //get camera list
      let deviceList = devices.filter(device => {
        if (device.kind === "videoinput") {
          return device;
        }
      });

      // decide media type
      let media =
        requestMediaType === mediaType.AUDIO_VIDEO  // req is for audio_video
          ? ((deviceList && deviceList.length) || isMobileOriPad()) &&  // devicelist is non empty for desktop || user is on mobile
            (this.props.uniqueId === this.props.organiser || !this.props.snapshotPermissionReply) // agent || snapshot  is not runing for user (dont share VIDEO, share only AUDIO)
            ? mediaType.AUDIO_VIDEO
            : mediaType.AUDIO
          : mediaType.AUDIO;

      let recordingEnable = false;
      if (this.props.modules.includes(Modules.RECORDING)
        && (this.props.recordingMethod === RECORDING_METHOD.AUTO
        || this.props.isRecording)
      ) {
        recordingEnable = true;
      }

      var message = {
        data: {
          category: socketMessage.category.WEBRTC,
          action: webRtcMessageId.SHARE_WEBRTC_MEDIA,
          sessionKey: this.props.sessionKey,
          media: media,
          recordingEnable: recordingEnable,
          recordingTarget: this.props.recordingTarget,
          audioStatus: audioStatus,
          videoStatus: videoStatus,
        }
      };
      // send SHARE_MEDIA req to create a media pipeline
      this.props.sendWebsocketMessage(
        socketMessage.events.MESSAGE,
        message
      );
    }).catch(function (err) {
      console.error(err.name + ": " + err.message);
    });
  }

  stopMediaTracksOfGivenStream = (stream) => {
    stream && stream.getTracks().forEach(track => {
      track.stop();
    });
  }

  sendCallRequestForMedia = (mediaType) => {
    if (this.props.webRtcPermissionRequest !== mediaType) { // check to avoid multiple audio / video calls
      let switchTimeout = 0;
      let self = this;
      setTimeout(function () {
        var message = {
          data: {
            category: socketMessage.category.WEBRTC,
            action: webRtcMessageId.WEBRTC_PERMISSION_REQUEST,
            sessionKey: self.props.sessionKey,
            media: mediaType,
            token: self.props.token
          }
        };
        self.props.sendWebsocketMessage(socketMessage.events.MESSAGE, message);
      }, switchTimeout);
      // set current media type being shared in gthe reducer
      this.props.sessionActions.updateWebRtcPermissionRequest(mediaType);
      // this flag when set true, will load AudioVideoContainer
      this.props.headerAction.setCallModalPermission(true);
      this.hideSpinner();
    }
  }

  handleScreenShareToggle = () => {
    if (!this.props.screenSharingParticipantId) {
      //If there is no more participants then doesn't make sense to call it.
      this.props.headerAction.resetParticipantsPluginInfo();
      if (!isWebRTCPluginInstalled()) return;   // for self - check and show toast msg for plugin uninstalled
      //if (!this.checkKMSStatus()) return
      //TODO: get room meta data and check if screenshare is null then send ws message

      let recordingEnable = false;
      if (
        this.props.modules.includes(Modules.RECORDING) &&
        (this.props.recordingMethod === RECORDING_METHOD.AUTO || this.props.isRecording)
      ) {
        recordingEnable = true;
      }
      var message = {
        data: {
          category: socketMessage.category.WEBRTC,
          action: webRtcMessageId.SHARE_WEBRTC_MEDIA,
          sessionKey: this.props.sessionKey,
          media: mediaType.SCREEN,
          recordingEnable: recordingEnable,
          recordingTarget: this.props.recordingTarget,
        }
      };
      this.props.sendWebsocketMessage(socketMessage.events.MESSAGE, message);
    } else if (!isMacOs && this.props.screenSharingParticipantId) {
      this.props.headerAction.setRunScreenShare(!this.props.runScreenShare);
    }
  }

  handleChatToggle = () => {
    this.setState({
      chatPopOver: !this.state.chatPopOver

    });
    this.props.setMessagesRead(true);
    if (this.state.chatPopOver) {
      // 
      this.props.displayMessage(false);
      this.props.headerAction.updateHeaderIconClass(Modules.CHAT, "moduleIcon", " cursorPointer");
    } else {
      // 
      this.setState({
        isMessageArrived: !this.state.isMessageArrived
      });
      let modulesInfo = this.props.headerIcons;
      modulesInfo[Modules.CHAT].logo = ic_message;
      this.props.headerAction.setHeaderIcons(modulesInfo);
      this.props.displayMessage(false);
      this.props.headerAction.updateHeaderIconClass(
        Modules.CHAT,
        "moduleIconActive",
        " cursorPointer"
      );
    }
  };

  handleSnapshotToggle = () => { };

  handleLocationToggle = (checkDownload, isLocationPermissionGranted = true) => {
    //isLocationPermissionGranted is set to false if user block location permission
    let isDownloaded = checkDownload || false;
    if (!this.state.locationPopOver && !this.checkParticipantsAvailable())
      return;
    //if (!this.checkKMSStatus()) return
    if (
      this.props.uniqueId === this.props.organiser &&
      this.state.locationPopOver === false &&
      !isDownloaded
    ) {
      var message = {
        data: {
          category: socketMessage.category.LOCATION,
          action: socketMessage.subCategories.LOCATION.START_LOCATION_SHARE,
          sessionKey: this.props.sessionKey
        }
      };
      this.props.sendWebsocketMessage(socketMessage.events.MESSAGE, message);
      this.props.addLocationParticipantId(this.props.uniqueId);
    } else {
      if (this.state.locationPopOver === true) {
        var message = {
          data: {
            category: socketMessage.category.LOCATION,
            action: socketMessage.subCategories.LOCATION.STOP_LOCATION_SHARE,
            sessionKey: this.props.sessionKey,
            isDownloaded: isDownloaded,
            isLocationPermissionGranted: isLocationPermissionGranted
          }
        };
        this.props.sendWebsocketMessage(socketMessage.events.MESSAGE, message);
        this.props.stopLocationShare();
      }
      this.props.updateLocationPermissionReply(null);
      this.props.headerAction.setLocationPopup(false);
      this.setState({
        locationPopOver: false
      });
    }
  };

  getSingleParticipant = () => {
    return this.props.admittedParticipants.filter(
      participant => participant.role == USER_ROLES.USER
    );
  };

  handleSnapshot = () => {
    if(this.props.customerCoBrowseStarted) {
      toastr.error(getMessage("SNAPSHOT_CANNOT_USE_WITH_CUSTOMER_CO_BROWSE"),
        {toastId: "SNAPSHOT_CANNOT_USE_WITH_CUSTOMER_CO_BROWSE"})
      return
    }

    if (!isWebRTCPluginInstalled()) return;   // for self - check and show toast msg for plugin uninstalled
    this.props.headerAction.resetParticipantsPluginInfo();
    // If snapshot request is accepted by participant then don't send snapshot request again
    if (this.props.snapshoteeId && this.props.snapshotPermissionReply) {
      this.props.headerAction.updateHeaderIconClass(
        Modules.SNAPSHOT,
        "moduleIconActive cursorDisabled",
        " cursorDisabled"
      );
      return;
    }

    //if (!this.checkKMSStatus()) return;
    let participant = this.getSingleParticipant()[0];
    if (!this.checkParticipantsAvailable()) return;
    this.props.headerAction.resetSnapshotData();
    // restore canvas to original position when snapshot is started at Agent side
    // this.props.sessionActions.setComponentInFocus(COMPONENT_IN_FOCUS.CANVAS);
    if (this.props.admittedParticipants.length > 2) {
      this.props.headerAction.setShowSnapshot(true);
    } else {
      const { sessionKey } = this.props;
      const message = {
        data: {
          category: socketMessage.category.WEBRTC,
          action: webRtcMessageId.SNAPSHOT_PERMISSION_REQUEST,
          sessionKey: sessionKey,
          snapshoteeId: participant.uniqueId,
          token: this.props.token
        }
      };
      this.props.sendWebsocketMessage(socketMessage.events.MESSAGE, message);
      this.props.sessionActions.updateSnapshoteeId(participant.uniqueId);
      this.props.sessionActions.updateSnapshotPermissionReply(null);
      this.props.headerAction.setShowSnapshot(true);
      this.props.headerAction.updateHeaderIconClass(
        Modules.SNAPSHOT,
        "moduleIconActive cursorDisabled",
        " cursorDisabled"
      );
    }
    //this.props.headerAction.setShowSnapshot(true);
  }

  handleAppEmulationToggle = () => {
    if (!this.state.showDeviceListModal && !this.checkParticipantsAvailable()) return;
    //if (!this.checkKMSStatus()) return
    this.setState({ showDeviceListModal: !this.state.showDeviceListModal })
  }

  handleOkClick = () => {
    this.setState({
      isParticipantAvailable: false
    });
  };

  checkParticipantswAvalaiblePopup = () => {
    if (this.state.isParticipantAvailable) {
      return (
        <Popup
          show={this.state.isParticipantAvailable}
          isDoubleButton={false}
          handleOkClick={this.handleOkClick}
          message={getMessage("PARTICIPANT_NOT_AVAILABLE")}
        />
      );
    }
  };

  checkParticipantsAvailable = () => {
    if (this.props.admittedParticipants.length <= 1) {
      this.setState({
        isParticipantAvailable: true
      });
      return false;
    }
    return true;
  };

  openDrawer = () => {
    this.setState({
      popoverOpen: !this.state.popoverOpen
    }, () => {
      if (this.state.popoverOpen) {
        document.body.style.overflow = "hidden";
      } else {
        if (isIE)
          document.body.style.overflow = "visible";
        else
          document.body.style.overflow = "overlay";
      }
    });
  };

  handleYesClick = (isCameraConnected = true, isMicConnected = true, isPluginInstalled = true) => {
    var message = {
      data: {
        category: socketMessage.category.WEBRTC,
        action: webRtcMessageId.WEBRTC_PERMISSION_REPLY,
        sessionKey: this.props.sessionKey,
        isGranted: true,
        media: this.props.webRtcPermissionRequest,
        isCameraConnected: isCameraConnected,
        isMicConnected: isMicConnected,
        isPluginInstalled
      }
    };
    this.props.sendWebsocketMessage(socketMessage.events.MESSAGE, message);
    this.props.headerAction.setCallStatus(false);
    this.sendShareMediaRequest(this.props.webRtcPermissionRequest);
    // this.props.headerAction.setCallModalPermission(true); // after yes click show Audio Video box
    this.setState({ isButtonClicked: false })
    this.props.sessionActions.updateWebRtcPermissionReply(true);
    this.props.headerAction.updateHeaderIconClass(
      this.props.webRtcPermissionRequest,
      "moduleIconActive cursorDisabled",
      " cursorDisabled"
    );
  };

  handleNoClick = (isCameraConnected = true, isMicConnected = true, isPluginInstalled = true) => {
    var message = {
      data: {
        category: socketMessage.category.WEBRTC,
        action: webRtcMessageId.WEBRTC_PERMISSION_REPLY,
        sessionKey: this.props.sessionKey,
        isGranted: false,
        media: this.props.webRtcPermissionRequest,
        isCameraConnected: isCameraConnected,
        isMicConnected: isMicConnected,
        isPluginInstalled
      }
    };

    this.props.sendWebsocketMessage(socketMessage.events.MESSAGE, message);
    // this.props.headerAction.setCallModalPermission(false);    
    this.props.sessionActions.updateWebRtcPermissionReply(false);
    this.setState({ isButtonClicked: false })
  };

  handleOutsideClickParticipantsList = (event) => {
    if (event.target.className == 'modal fade show') {
      this.setState({ showWaitingArea: false})
      document.removeEventListener('click', this.handleOutsideClickParticipantsList)
    }
  }

  handleOutsideClickEndMeeting = (event) => {
    if (event.target.className == 'modal fade show') {
      this.setState({
        showEndSessionConfirmationModal: false
      })
      document.removeEventListener('click', this.handleOutsideClickEndMeeting)
    }
  }

  handleSnapshotYesClick = async () => {
    // for participant - check and show toast msg and send plugin status in snapshotPermissionReply
    let isWebRTCPluginInstalledFlag = isWebRTCPluginInstalled();
    if (!isWebRTCPluginInstalledFlag) {
      this.handleSnapshotNoClick(true, isWebRTCPluginInstalledFlag);
      return;
    }

    // restore canvas to original position when snapshot is started at User side
    // this.props.sessionActions.setComponentInFocus(COMPONENT_IN_FOCUS.CANVAS);
    await navigator.mediaDevices.enumerateDevices().then(devices => {
      let isVideoDevices = devices.filter(device => {
        if (device.kind === "videoinput") {
          return true;
        }
      });
      if (isVideoDevices.length > 0) {
        this.showSpinner();
        var message = {
          data: {
            category: socketMessage.category.WEBRTC,
            action: webRtcMessageId.SNAPSHOT_PERMISSION_REPLY,
            sessionKey: this.props.sessionKey,
            snapshoterId: this.props.snapshoterId,
            isGranted: true,
            isUserWebCamPresent: true
          }
        };
        this.props.sendWebsocketMessage(socketMessage.events.MESSAGE, message);

        if (this.props.snapshotPermissionReply == false) {
          this.props.sessionActions.updateSnapshotPermissionReply(true);
        }
        this.hideSpinner();
      } else {
        // if there isnt device connected then reject snapshot request with flag isDeviceAttached = true
        this.handleSnapshotNoClick(false);//isDeviceAttached=false
        toastr.error(getMessage("WEBCAM_NOT_CONNECTED"))
      }
    });

    //this.props.sessionActions.updateSnapshotPermissionReply(true);
  };

  handleSnapshotNoClick = (isDeviceAttached = true, isPluginInstalled = true) => {
    //  we check isDeviceAttached or not only if user accept snapshot request, otherwise isDeviceAttached =true
    var message = {
      data: {
        category: socketMessage.category.WEBRTC,
        action: webRtcMessageId.SNAPSHOT_PERMISSION_REPLY,
        sessionKey: this.props.sessionKey,
        snapshoterId: this.props.snapshoterId,
        isGranted: false,
        isUserWebCamPresent: isDeviceAttached,
        isPluginInstalled
      }
    };
    this.props.sendWebsocketMessage(socketMessage.events.MESSAGE, message);
  };

  handleAppEmulationYesClick = () => {
    var message = {
      data: {
        category: socketMessage.category.APP_EMULATION,
        action: webRtcMessageId.PERMISSION_REPLY,
        sessionKey: this.props.sessionKey,
        isGranted: true
      }
    };

    this.props.sendWebsocketMessage(socketMessage.events.MESSAGE, message);
    this.props.appEmulationAction.updateAppEmulationPermissionRequest(false);
  }

  handleAppEmulationNoClick = () => {
    var message = {
      data: {
        category: socketMessage.category.APP_EMULATION,
        action: webRtcMessageId.PERMISSION_REPLY,
        sessionKey: this.props.sessionKey,
        isGranted: false
      }
    };

    this.props.sendWebsocketMessage(socketMessage.events.MESSAGE, message);
    this.props.appEmulationAction.updateAppEmulationPermissionReply(false);
    this.props.appEmulationAction.updateAppEmulationPermissionRequest(false);
  }

  // called only by presenter when cobrowse header icon is toggled
  sendCoBrowseRequest = (newParticipantId) => {
    if (this.props.isPresenter) {
      const message = {
        data: {
          category: socketMessage.category.CO_BROWSE,
          action: socketMessage.subCategories.CO_BROWSE.PERMISSION_REQUEST,
          uniqueId: this.props.uniqueId,
          sessionKey: this.props.sessionKey,
          newParticipantId,
          layoutCode: this.props.layoutCode
        }
      };
      this.props.sendWebsocketMessage(socketMessage.events.MESSAGE, message);
    }
  }

  removeActiveFrame = () => {
    const message = {
      data: {
        category: socketMessage.category.PDF,
        action: socketMessage.subCategories.PDF.FREEZE_FRAME,
        canvasId: this.props.activeCanvas.canvasId,
        isFrameLocked: false,
        sessionKey: this.props.sessionKey,
        participantId: null
      }
    };
    this.props.sendWebsocketMessage(socketMessage.events.MESSAGE, message);
  };

  handleLocationYesClick = () => {
    var message = {
      data: {
        category: socketMessage.category.LOCATION,
        action: socketMessage.subCategories.LOCATION.SHARE_LOCATION_PERMISSION,
        sessionKey: this.props.sessionKey,
        isGranted: true
      }
    };

    this.props.sendWebsocketMessage(socketMessage.events.MESSAGE, message);
    this.props.headerAction.setLocationPopup(false);
    this.setState({
      locationPopOver: true
    });
  };

  handleLocatioNoClick = () => {
    var message = {
      data: {
        category: socketMessage.category.LOCATION,
        action: socketMessage.subCategories.LOCATION.SHARE_LOCATION_PERMISSION,
        sessionKey: this.props.sessionKey,
        isGranted: false
      }
    };
    this.props.sendWebsocketMessage(socketMessage.events.MESSAGE, message);
    this.props.headerAction.setLocationPopup(false);
  };

  /**
   * Turn ContractInfoModal on <-> off
   */
  toggleContractInfoModal = () => {
    // from Parent (HeaderContainer.js)
    this.props.toggleContractInfoModal();
  }

  /**
   * if contractDisplayMethid is 'AUTO',
   * Open contract info in new tab, automatically.
   */
  autoOpenContractInfo = () => {
    // Must be SUPPORT_CENTER
    const modules = this.props.modules;
    if (modules.indexOf(Modules.SUPPORT_CENTER) < 0) {
      return;
    }

    // userProfileData must have operatorSkills
    const userProfileData = this.props.userProfileData;
    if (!userProfileData.hasOwnProperty('operatorSkills')) {
      return;
    }
    const operatorSkills = userProfileData.operatorSkills;

    // Get skillName from sessionName
    const sessionName = this.props.sessionName;
    const skillName = sessionName.split('/')[0];

    // each of operatorSkills
    operatorSkills.forEach((skill) => {
      if (skill.name === skillName && skill.contractDisplayMethod === 'AUTO') {
        const contractInfo = this.props.contractInfo;
        contractInfo.forEach((info) => {
          window.open(info.url, info.label);
        });
      }
    })
  }

  getClassForTextLabel = (item) => {
    const label = this.props.language == LANGUAGE.EN.name
      ? this.props.headerIcons[item].title === getMessage("SCREENSHARE") ||
        this.props.headerIcons[item].title === getMessage("APP_EMULATION") ||
        this.props.headerIcons[item].title === getMessage("CO_BROWSE")
        ? "mb-0 enModuleLabel engLargeModuleLabelWidth pt-1"
        : "mb-0 enModuleLabel engSmallModuleLabelWidth pt-1"
      : this.props.headerIcons[item].title == getMessage("SNAPSHOT")
        ? "mb-0 jaModuleLabel jaLargeModuleLabelWidth pt-1"
        : "mb-0 jaModuleLabel jaSmallModuleLabelWidth pt-1";
    return `${label} ${this.props.headerIcons[item].textLabelClass}`;
  };

  renderModules = (isMobileDevice = false) => {
    if (this.props.headerIcons.length !== 0) {
      if (this.props.sessionStatus !== SESSION_STATUS.ACTIVE) return;

      if (this.props.headerIcons.length <= 0) return;

      const modules = Object.keys(this.props.headerIcons).map(item => {
        if (
          this.props.organiser !== this.props.uniqueId &&
          (item === Modules.LOCATION && item === Modules.APP_EMULATION)
        )
          return;
        if (isMobileDevice) {
          return (
            <Row
              onClick={() => {
                if (item !== Modules.SCREENSHARE ||
                  (item === Modules.SCREENSHARE && !isAndroidOrIos())) this.handleModuleClick(item);
              }}
              key={this.props.headerIcons[item].title}
              className={this.props.headerIcons[item].class + " pt-2 pb-2"}
            >
              <Col md="2" sm="2" xs="2">
                <img
                  src={this.props.headerIcons[item].logo}
                  title={this.props.headerIcons[item].title}
                  className="add-img p-0"
                />
              </Col>
              <Col md="10" sm="10" xs="10"
                className={(this.props.userRole === USER_ROLES.USER
                  && !this.props.headerIcons[item].userAllowed || (item===Modules.CO_BROWSE && this.props.uniqueId !== this.props.presenter)
                  || (item === Modules.SCREENSHARE && isAndroidOrIos()))
                  ? "p-left text-left colorGrey"
                  : "p-left text-left cursorPointer"}>
                {getMessage(this.props.headerIcons[item].title)}
              </Col>
            </Row>
          );
        }
        return (
          <div className={"headerIconDiv " + (this.state.iconLarge ? 'enlarge' : "")}
            key={this.props.headerIcons[item].title + "_div"}
          >
            <span
              className={this.props.headerIcons[item].class}
              onClick={() => this.handleModuleClick(item)}
              key={this.props.headerIcons[item].title}
              id={item}
            >
              <img
                src={this.props.headerIcons[item].logo}
                title={this.props.headerIcons[item].title}
                className={
                  isModuleIconToBeDisabled(item, {
                    organiser: this.props.organiser,
                    uniqueId: this.props.uniqueId,
                    webRtcPermissionRequest: this.props.webRtcPermissionRequest,
                    snapshoteeId: this.props.snapshoteeId,
                    screenSharingParticipantId: this.props.screenSharingParticipantId,
                    userRole: this.props.userRole,
                    isPresenter: this.props.isPresenter,
                    showCoBrowse: this.props.showCoBrowse,
                    isSnapshotStarted: this.isSnapshotStarted(),
                    cobrowseTypes: this.props.cobrowseType,
                    customerCoBrowseStarted: this.props.customerCoBrowseStarted
                  })
                    ? "" : "blinkImg"
                }
              />
            </span>
            <label
              className={this.getClassForTextLabel(item)}
              onClick={() => this.handleModuleClick(item)}
            >
              {getMessage(this.props.headerIcons[item].title)}
            </label>
          </div>
        );
      });

      const waitingParticipants = this.props.allParticipants.filter(participant =>
        participant.admissionStatus == USER_ADMISSION_STATUS.PENDING
        && (participant.status === "ACTIVE" || participant.status === "WAITING")
        && participant.uniqueId);
      return (
        <>
          <div className="buttonDisplay">
            {this.renderScreenMaskingIcon(true)}
            {this.renderRecordingIcon(true)}
            {this.props.organiser === this.props.uniqueId && this.props.loggingLevel === "ADVANCED" && (
              <span className="headerRightIcons">
                <img
                  src={ic_save_icon}
                  className="button saveButton showSave"
                  onClick={this.props.saveSessionData}
                  title={getMessage("SAVE")}
                />
              </span>
            )}
            <span className="headerRightIcons">
              <img
                src={ic_participants}
                className="saveButton showSave"
                onClick={() => {
                  this.state.popoverOpen = false;
                  this.showWaitingArea(); 
                }}
                title={getMessage("PARTICIPANTS")}
              />
              {this.props.organiser === this.props.uniqueId
                && waitingParticipants.length > 0
                && (<span className="badge showBadge">{waitingParticipants.length}</span>)}
            </span>
          </div>
          <div className="dropdown-divider dividerLine" />
          {
            modules
          }
        </>
      )
    }
  };

  /**
   * recording button
   * @param {boolean} mobileView 
   * @returns 
   */
  renderRecordingIcon = (mobileView) => {
    if (this.props.userRole === USER_ROLES.AGENT 
      && this.props.modules.includes(Modules.RECORDING)
      && this.props.recordingMethod === RECORDING_METHOD.MANUAL
      && this.props.recordingTarget?.length) {
      return(
        <span className={mobileView ? "headerRightIcons" : "headerRightIcons pt-0 pt-lg-1"}>
          <img
            src={this.props.isRecording
              ? ic_rec_stop_icon
              : ic_rec_start_icon}
            className={mobileView ? "button saveButton showSave" : "button cursorPointer"}
            onClick={this.handleRecordingIconClick}
            title={this.props.isRecording
              ? getMessage("STOP_RECORDING")
              : getMessage("START_RECORDING")} 
          />
        </span>
      )
    }
  }

  handleRecordingIconClick = () => {
    var message = {
      data: {
        category: socketMessage.category.WEBRTC, 
        action: webRtcMessageId.SET_IS_RECORDING,
        sessionKey: this.props.sessionKey,
        recordingEnable: !this.props.isRecording,
      }
    };
    // send SHARE_MEDIA req to create a media pipeline
    this.props.sendWebsocketMessage(
      socketMessage.events.MESSAGE,
      message
    );
    this.props.headerAction.setIsRecording(!this.props.isRecording);
  }

  renderScreenMaskingIcon = (mobileView) => {
    if (this.props.screenMaskSetting && this.props.screenMaskSetting.mode == SCREEN_MASK_MODE.NOT_USE) {
      return
    }
    const modules = this.props.modules;
    if (
      (
        (!this.props.screenMaskSetting && this.props.isPresenter)
        || (this.props.screenMaskSetting && this.props.screenMaskSetting.mode == SCREEN_MASK_MODE.PRESENTER && this.props.isPresenter)
        || (this.props.screenMaskSetting && this.props.screenMaskSetting.mode == SCREEN_MASK_MODE.AGENT && this.props.userRole === USER_ROLES.AGENT)
      )
      && (modules.indexOf(Modules.SCREENSHARE) !== -1 || modules.indexOf(Modules.CO_BROWSE) !== -1)
    ) {
      return(
        <span className={mobileView ? "headerRightIcons" : "headerRightIcons pt-0 pt-lg-1"}>
          <img
            src={this.props.isScreenMasking
              ? ic_screen_masking_stop
              : ic_screen_masking_start}
            className={mobileView ? "button saveButton showSave" : "button cursorPointer"}
            onClick={this.handleScreenMaskingIconClick}
            title={this.props.isScreenMasking
              ? getMessage("STOP_SCREEN_MASKING")
              : getMessage("START_SCREEN_MASKING")} 
          />
        </span>
      )
    }
  }

  handleScreenMaskingIconClick = () => {
    var message = {
      data: {
        category: socketMessage.category.WEBRTC, 
        action: webRtcMessageId.SET_IS_SCREEN_MASKING,
        sessionKey: this.props.sessionKey,
        screenMaskingEnable: !this.props.isScreenMasking,
      }
    };
    // send SHARE_MEDIA req to create a media pipeline
    this.props.sendWebsocketMessage(
      socketMessage.events.MESSAGE,
      message
    );
    this.props.headerAction.setIsScreenMasking(!this.props.isScreenMasking);
  }

  showCustomerCoBrowsePermissionModal = () => {
    if (this.props.customerCoBrowsePermissionRequest && this.props.customerCoBrowsePermissionReply === null) {
      if(this.state.isReductionLogs){
        return;
      }else{
        return (
          <Popup
            show={this.props.presenter !== this.props.uniqueId}
            isDoubleButton={true}
            handleYesClick={this.handleCustomerCoBrowseYesClick}
            handleNoClick={this.handleCustomerCoBrowseNoClick}
            message={getMessage("CUSTOMER_CO_BROWSE_PERMISSION")}
            isPermissionPopup={true}
          ></Popup>
        );
      }
    }
  };

  /**
   * オーナー側で「共同閲覧」を実行した際のフォロワー側の認否ダイアログの「許可」ボタンに対応
   */
  handleCustomerCoBrowseYesClick = () => {
    // FIXME: 現行か新アーキテクチャか判定する
    if (this.props.cobrowseType === cobrowseTypes.CUSTOMER_CO_BROWSE) {
      // 【現行】
      var message = {
        data: {
          category: socketMessage.category.CUSTOMER_CO_BROWSE,
          action: socketMessage.subCategories.CUSTOMER_CO_BROWSE.PERMISSION_REPLY,
          sessionKey: this.props.sessionKey,
          isGranted: true
        }
      };
      this.props.sendWebsocketMessage(socketMessage.events.MESSAGE, message);
      customerCoBrowseAction.updateCustomerCoBrowsePermissionReply(true);
      customerCoBrowseAction.showHideCustomerCoBrowse(true);
    } else {
      // 【新】
      // REST の joinSession を呼ぶ前に、WS の PERMISSION_REPLY（これ）を呼んでおかないと、
      // exCloserSV 側で「存在しないフォロワー」と判断される
      var message = {
        data: {
          category: socketMessage.category.APP_EMULATION,
          action: webRtcMessageId.PERMISSION_REPLY,
          sessionKey: this.props.sessionKey,
          isGranted: true
        }
      };
      this.props.sendWebsocketMessage(socketMessage.events.MESSAGE, message);
      // ------------------------------------------------------------------------
      // フォロワー用のセッション開始APIへ送信するpayloadを生成する（REST）
      let data = {
        userName: this.props.userName,
        sessionKey: this.props.sessionKey,
        uniqueId: this.props.uniqueId,
        customerId: this.props.customerId,
        // roomId: this.props.sessionKey,  // 2022-12-07 ADD
        serverName: JSON.parse(sessionStorage.getItem("state")).CustomerCoBrowseReducer.serverName,
      };
      // フォロワー用のセッション開始APIを叩く
      customerCoBrowseActionV2.joinFollowerSession(data).then(
        response => {
          console.log('joinSession時のresponse.data ==========>', response.data)
          console.log('フォロワー用のAppEmulationUrl ==========>', response.data.appEmulationUrl)

          // exCloserSV から取得したフォロワー用の `コンテンツ描画URL` をREDUXのstoreに格納しておく
          customerCoBrowseActionV2.setAppEmulationUrlForFollower(response.data.appEmulationUrl)
          // When you reconnect, the presenter returns to the agent, so if you replace the presenter, you do not need to reconnect.
          // Save reconnect information only when guests join
          if (this.props.userRole === 'USER') {
            sessionStorage.setItem('reconnectionUrlForFollower', response.data.appEmulationUrl);
          }
        },
        error => {
          toastr.error(getMessage(error.code));
        }
      );
      // ------------------------------------------------------------------------
      // 2022-12-07 これまで通りのCustomerCoBrowseのWS
      var message = {
        data: {
          category: socketMessage.category.CUSTOMER_CO_BROWSE,
          action: socketMessage.subCategories.CUSTOMER_CO_BROWSE.PERMISSION_REPLY,
          sessionKey: this.props.sessionKey,
          isGranted: true
        }
      };
      this.props.sendWebsocketMessage(socketMessage.events.MESSAGE, message);
      // ------------------------------------------------------------------------
      // 2022-12-07 ここから下２行はこれまで通り
      customerCoBrowseActionV2.updateCustomerCoBrowsePermissionReply(true);
      customerCoBrowseActionV2.showHideCustomerCoBrowse(true);
    }
  }

  handleCustomerCoBrowseNoClick = () => {
    var message = {
      data: {
        category: socketMessage.category.CUSTOMER_CO_BROWSE,
        action: socketMessage.subCategories.CUSTOMER_CO_BROWSE.PERMISSION_REPLY,
        sessionKey: this.props.sessionKey,
        isGranted: false
      }
    };
    this.props.sendWebsocketMessage(socketMessage.events.MESSAGE, message);
    customerCoBrowseAction.updateCustomerCoBrowsePermissionReply(false);
  }

  showLocationPermissionModal = () => {
    if (
      !this.state.locationPopOver &&
      this.props.locationPermissionReply === null &&
      (this.props.isLocation || this.props.isLocationSharing)
    ) {
      if(this.state.isReductionLogs){
        return;
      }else{
        return (
          <Popup
            show={this.props.organiser !== this.props.uniqueId} //this.props.userRole !== USER_ROLES.AGENT
            isDoubleButton={true}
            onClose={this.onClose}
            handleYesClick={this.handleLocationYesClick}
            handleNoClick={this.handleLocatioNoClick}
            message={getMessage("AGENT_LOCATION_PERMISSION")}
            isPermissionPopup={true}
          ></Popup>
        );
      }
    } else if (
      !this.state.locationPopOver &&
      this.props.locationPermissionReply &&
      this.props.isLocationSharing
    ) {
      this.setState({
        locationPopOver: true
      });
    }
  };

  showSnapshotPermissionModal = () => {
    if (this.props.snapshoteeId !== this.props.uniqueId) {
      return;
    }
    if (this.props.organiser !== this.props.uniqueId &&
      this.props.snapshoteeId &&
      this.props.uniqueId &&
      this.props.snapshoteeId === this.props.uniqueId &&
      this.props.snapshotPermissionReply === null) {
      if (!isWebRTCSupported()) {
        this.handleSnapshotNoClick()
        return;
      }
    }

    if(this.state.isReductionLogs && !isSafari){
      return;
    }else{
      return (
        <Popup
          show={
            /**this.props.userRole !== USER_ROLES.AGENT */
            this.props.organiser !== this.props.uniqueId &&
            this.props.snapshoteeId &&
            this.props.uniqueId &&
            this.props.snapshoteeId === this.props.uniqueId &&
            this.props.snapshotPermissionReply === null
          }
          isDoubleButton={true}
          onClose={this.onClose}
          handleYesClick={this.handleSnapshotYesClick}
          handleNoClick={this.handleSnapshotNoClick}
          message={getMessage("AGENT_SNAPSHOT_PERMISSION")}
          isPermissionPopup={true}
        />
      );
    }
  };

  checkDevicesAreConnectOrNot = () => {
    this.setState({ isButtonClicked: true })
    if (isMobileOriPad()) {
      this.handleYesClick(true, true, true);
    } else {
      // for participant - check and show toast msg and send plugin status in webRtcPermissionReply (audio / video)
      let isWebRTCPluginInstalledFlag = isWebRTCPluginInstalled();
      if (!isWebRTCPluginInstalledFlag) {
        this.handleNoClick(true, true, isWebRTCPluginInstalledFlag);
        return;
      }

      navigator.mediaDevices.enumerateDevices().then(devices => {
        let isVideoDevicesConnected = []
        let isAudioDevicesConnected = devices.filter(device => {
          if (device.kind === "audioinput") {
            return true;
          }
        });
        if (this.props.webRtcPermissionRequest === mediaType.AUDIO_VIDEO) {
          isVideoDevicesConnected = devices.filter(device => {
            if (device.kind === "videoinput") {
              return true;
            }
          });
        }

        isAudioDevicesConnected = isAudioDevicesConnected.length > 0;
        isVideoDevicesConnected = this.props.webRtcPermissionRequest === mediaType.AUDIO_VIDEO ?
          isVideoDevicesConnected.length > 0 : true

        if ((this.props.webRtcPermissionRequest === mediaType.AUDIO_VIDEO && isAudioDevicesConnected) ||
          isVideoDevicesConnected && isAudioDevicesConnected) {

          if (this.props.webRtcPermissionRequest === mediaType.AUDIO_VIDEO) {
            // call getUserMedia to check if camera is available / not busy
            // call getUserMedia because safari only gets default devices until after getUserMedia is called,
            // due to which stream is not displayed when we start call first time from a tab
            navigator.mediaDevices.getUserMedia({ video: true })  // getUserMedia will fail if camera is busy / unavailable
            .then(stream => {
              this.stopMediaTracksOfGivenStream(stream);  // stop streams retrieved as Video component will retrieve it
              this.handleYesClick(isVideoDevicesConnected, isAudioDevicesConnected, true);
            }).catch((error) => {
              // we will not show toaster here because it will be shown when video component is loaded and getUserMedia is called by WebRTC
              console.error('getUserMedia error: ', error);
              this.handleYesClick(isVideoDevicesConnected, isAudioDevicesConnected, true);
            });
          } else {
            // call getUserMedia to check if audio device is available / not busy
            // call getUserMedia to fix WAAG-4944 because safari only gets default devices until after getUserMedia is called.
            navigator.mediaDevices.getUserMedia({ audio: true })  // getUserMedia will fail if audio is busy / unavailable
            .then(stream => {
              this.stopMediaTracksOfGivenStream(stream);  // stop streams retrieved as Video component will retrieve it
              // send share media request
              this.handleYesClick(isVideoDevicesConnected, isAudioDevicesConnected, isWebRTCPluginInstalled());
            })
            .catch((error) => {
              this.handleNoClick(isVideoDevicesConnected, false, isWebRTCPluginInstalled());
              let errorMessage = getUserMediaError(error, mediaType.AUDIO);
              if (errorMessage) {
                this.hideSpinner();
                toastr.error(getMessage(errorMessage))
              }
            });          
          }
          //displaying message at user side if camera or mic not found
          if (!isVideoDevicesConnected) {
            toastr.error(getMessage("WEBCAM_NOT_CONNECTED"))
          }
          if (!isAudioDevicesConnected) {
            toastr.error(getMessage("MIC_NOT_CONNECTED"))
          }
        } else {
          //No any devices connected to make call or webRTC plugin not installed 
          toastr.error(getMessage("DEVICE_NOT_FOUND"));
          this.handleNoClick(isVideoDevicesConnected, isAudioDevicesConnected, isWebRTCPluginInstalled());
        }
      });
    }
  }

  showPermissionModal = () => {
    // If webRTC is not supported, reject the request
    if (this.props.webRtcPermissionRequest !== null &&
      this.props.webRtcPermissionReply === null &&
      this.props.organiser !== this.props.uniqueId ||
      (this.props.isSessionEnded &&
        this.props.organiser === this.props.uniqueId))
      if (!isWebRTCSupported()) {
        this.handleNoClick(true, true, true)
        return;
      }

    if (!this.state.isButtonClicked && this.props.webRtcPermissionRequest !== null &&
      this.props.webRtcPermissionReply === null &&
      this.props.organiser !== this.props.uniqueId ||
      (this.props.isSessionEnded &&
        this.props.organiser === this.props.uniqueId)) {
      let message;
      if (this.props.isSessionEnded) {
        message = (this.props.organiser === this.props.uniqueId || this.props.isOrganizer)
          ? getMessage("AGENT_HAS_LOG_OUT")
          : getMessage("AGENT_HAS_ENDED_THE_SESSION");
      } else if (this.props.webRtcPermissionRequest === mediaType.AUDIO) {
        message = getMessage("AGENT_PERMISSION_AUDIO");
      } else {
        message = getMessage("AGENT_PERMISSION_VIDEO");
      }
      if(this.state.isReductionLogs && !isSafari){
        return;
      }else{
        return (
          // TODO: [RM#2325] Commented out getMessage. This is a temporary measure.
          <Popup
            show={true}
            isDoubleButton={this.props.isSessionEnded ? false : true}
            onClose={this.onClose}
            handleYesClick={this.checkDevicesAreConnectOrNot}
            handleNoClick={this.handleNoClick}
            message={message}
            warningMessage={!this.props.isSessionEnded &&
              (this.props.webRtcPermissionRequest === mediaType.AUDIO
                || this.props.webRtcPermissionRequest === mediaType.AUDIO_VIDEO)
              && this.props.modules.includes(Modules.RECORDING)
              && (this.props.recordingTarget.length !== 0)
              && (this.props.recordingMethod === RECORDING_METHOD.AUTO
                || (this.props.recordingMethod === RECORDING_METHOD.MANUAL && this.props.isRecording))
              && "" /*getMessage("MEETING_WILL_BE_RECORDED")*/}
            isPresenter={this.props.isPresenter}
            organiser={this.props.organiser}
            uniqueId={this.props.uniqueId}
            isOrganizer={this.props.isOrganizer}
            cleanUp={() => this.props.setToken(null)}
            isPermissionPopup={true}
            isAudioVideoPermissionPopUp={!this.props.isSessionEnded &&
              (this.props.webRtcPermissionRequest === mediaType.AUDIO
                || this.props.webRtcPermissionRequest === mediaType.AUDIO_VIDEO)
              ? true
              : false}
          />
        );
      }  
    }
  };

  showAppEmulationPermissionPopUp = () => {
    return (
      <Popup
        show={
          this.props.appEmulationPermission && !this.props.appEmulationPermisssionReply && this.props.userRole === USER_ROLES.USER
        }
        isDoubleButton={this.props.isSessionEnded ? false : true}
        handleYesClick={this.handleAppEmulationYesClick}
        handleNoClick={this.handleAppEmulationNoClick}
        message={getMessage("AGENT_PERMISSION_APP_EMULATION")}
        isPresenter={this.props.isPresenter}
        isAppEmulation={true}
        isPermissionPopup={true}
      />
    );
  }

  addInviteeHandle = () => {
    this.setState({ addInvitee: !this.state.addInvitee });
  };

  addInvitee = () => {
    return (
      <AddInviteeContainer
        show={this.state.addInvitee}
        addInviteeHandle={this.addInviteeHandle}
        sessionLink={this.state.sessionLink}
      />
    );
  };

  showWaitingArea = () => {
    this.setState({ showWaitingArea: !this.state.showWaitingArea })
    this.closeModal = this.handleOutsideClickParticipantsList.bind(this);
    document.addEventListener('click', this.handleOutsideClickParticipantsList)
  }

  showMakePresenter = (participantsId, presenterName) => {
    this.setState({
      makePresenterPopoverOpen:
        participantsId === this.state.makePresenterPopoverOpen
          ? ""
          : participantsId,
      presenterName: presenterName
    });
  };

  makePresenter = participant => {
    if (!navigator.onLine) {
      toastr.error(getMessage("NETWORK_ERROR"));
      return;
    }
    const { userName, uniqueId } = participant;
    if (this.props.frameLockedParticipantId !== null)
      this.removeActiveFrame();
    this.showMakePresenter(this.state.makePresenterPopoverOpen, userName);
    var message = {
      data: {
        category: socketMessage.category.NOTIFICATION,
        action: socketMessage.subCategories.NOTIFICATION.MAKE_PRESENTER,
        sessionKey: this.props.sessionKey,
        newPresenterId: uniqueId
      }
    };
    this.props.sendWebsocketMessage(socketMessage.events.MESSAGE, message);
    // After replacing the presenter, the reconnection information is deleted because it is not subject to reconnection.
    sessionStorage.removeItem('reconnectionUrl');
    sessionStorage.removeItem('reconnectionUrlForFollower');
  };

  showMoreParticipants = () => {
    this.setState({
      moreParticipantsPopOver: !this.state.moreParticipantsPopOver
    })
  }

  onOpenCloseEndSessionConfirmationModal = (modalState) => {
    if (modalState && !navigator.onLine) {
      toastr.error(getMessage("NETWORK_ERROR"));
      return;
    }
    this.setState({
      showEndSessionConfirmationModal: modalState
    })
    this.handleOutsideClickEndMeeting = this.handleOutsideClickEndMeeting.bind(this);
    document.addEventListener('click', this.handleOutsideClickEndMeeting)
  }

  onOpenCloseLeaveSessionConfirmationModal = (modalState) => {
    // will not check n/w offline for user and will allow user to leave any time
    this.setState({
      showLeaveSessionConfirmationModal: modalState
    })
  }

  admitOrRejectUserInSession = (isAdmitted, uniqueId, fromToast) => {
    if(fromToast) {
      toast.dismiss(TOAST_ID.ADMIT + uniqueId);
    } 
  
    // update participants admissionStatus in reducer at agent side
    if (!navigator.onLine) {
      //If Agent is offline ,he must see the network Error
      toastr.error(getMessage("NETWORK_ERROR"));
      return;
    }
    headerAction.setParticipantAdmittedOrRejected({
      uniqueId: uniqueId,
      isAdmitted: isAdmitted,
    });

    let message = {
      data: {
        category: socketMessage.category.SESSION,
        action:
          socketMessage.subCategories.SESSION.JOIN_SESSION_REPLY,
        isAdmitted: isAdmitted,
        uniqueId: uniqueId,
        sessionKey: this.props.sessionKey
      },
    };
    this.props.sendWebsocketMessage(socketMessage.events.MESSAGE, message);
  }

  handleAllowEdit = (isEditAllowed, participantId) => {
    const message = {
      data: {
        category: socketMessage.category.SESSION,
        action: socketMessage.subCategories.SESSION.ALLOW_EDIT_ACCESS,
        sessionKey: this.props.sessionKey,
        allowEditAccess: isEditAllowed,
        participantId: participantId
      }
    };
    this.props.sendWebsocketMessage(socketMessage.events.MESSAGE, message);
  }

  /**
   * This function is used to resolve following issue when app emulation session is started.
   * Issue - An agent cannot admit new participants unless app emulation session(app emulation popup) is closed.
   * If the value is true, it will show waiting area on app emulation popup when new participant arrives
   * so that agent can admit new participants in the session.
   */
  setAppEmulationStatus = (value) => {
    this.setState({
      isAppEmulationStarted: value
    });
  }

  renderPreviewModal = () => {
    return <PreviewModal
      show={this.state.showPreviewModal}
      handlePreviewModalCancelClick={this.handlePreviewModalCancelClick}
      handlePreviewModalStartClick={this.handlePreviewModalStartClick}
      isStart={true}
      currentReverse={this.props.isVideoTransform}
      currentAudioDeviceId={this.props.audioDeviceId}
      currentVideoDeviceId={this.props.videoDeviceId}
      currentFacingMode={this.props.facingMode}
      currentVirtualBackground={this.props.isVirtualBackground}
      currentSelectedBackground={this.props.selectedBackground}
    />;
  }

  handlePreviewModalCancelClick = () => {
    this.props.headerAction.setShowPreviewModal(false);
  }

  handlePreviewModalStartClick = (
    previewAudio, previewVideo, previewReverse, audioDeviceId, videoDeviceId, facingMode,
    previewVirtualBackground, selectedBackground,
  ) => {
    this.props.headerAction.setShowPreviewModal(false);
    this.props.headerAction.setVideoTransform(previewReverse);
    this.props.headerAction.setPreviewAudio(previewAudio);
    if(isMobileOriPad()) {
      this.props.headerAction.setFacingMode(facingMode);
    } else {
      this.props.headerAction.setMediaDevice(audioDeviceId, videoDeviceId);
    }
    this.props.headerAction.setVirtualBackground(previewVirtualBackground, selectedBackground);

    this.handleAudioVideoToggle(previewAudio ? mediaStatus.UNMUTED : mediaStatus.MUTED, previewVideo ? mediaStatus.UNMUTED : mediaStatus.MUTED);
    this.props.headerAction.updateHeaderIconClass(
      Modules.AUDIO_VIDEO,
      "moduleIconActive cursorDisabled",
      " cursorDisabled"
    );
  }

  handleShowAudioVideoPreview = async () => {
    if (this.props.webRtcPermissionRequest == mediaType.AUDIO_VIDEO) return;
    headerAction.setShowPreviewModal(true);
  }

  render = () => {
    let waitingParticipants = this.props.allParticipants.filter(participant =>
      participant.admissionStatus == USER_ADMISSION_STATUS.PENDING
      && (participant.status === "ACTIVE" || participant.status === "WAITING")
      && participant.uniqueId);
    return (

      <div className="header" id="commonHeader">
        {/* TODO: find some other solution to cache font family
        */}
        {Object.keys(FONT_FAMILY).map(fontFamily => {
          return <div className={FONT_FAMILY[fontFamily]} key={fontFamily}>
            {getMessage(fontFamily)}
          </div>
        })}
        {this.showPermissionModal()}
        {this.showSnapshotPermissionModal()}
        {this.showLocationPermissionModal()}
        {this.checkParticipantswAvalaiblePopup()}
        {/*this.showAppEmulationPermissionPopUp()*/}
        {this.showCustomerCoBrowsePermissionModal()}
        {this.renderSprinner()}
        { this.props.isEnableShowPreview &&
          this.renderPreviewModal()
        }
        <Row className="noMargin">
          <Col
            xl="4"
            lg="3"
            sm="12"
            md="12"
            xs="12"
            className="headerLogoContainer displayFlex noPadding pl-3 pr-xl-2"
          >
            {/* <a target="_new" href={sessionLink}> */}
            <div className="headerLogoDiv">
              <img
                className="headerLogo"
                src={this.props.logoUrl}
                alt="header logo"
              />
            </div>
            {/* </a> */}
            <div className="sessionTitle">
              <div className="title noPadding" title={this.props.sessionTitle}>
                {this.props.sessionTitle}
              </div>

              <div className="buttonDisplay">
                {this.props.organiser === this.props.uniqueId ? (
                  <Button
                    className="saveButton showSave endSession whiteOnClick"
                    onClick={() => {
                      this.onOpenCloseEndSessionConfirmationModal(true)
                    }}
                  >
                    {getMessage("END_SESSION")}
                  </Button>
                ) :
                  (
                    this.props.organiser !== "" &&
                    this.props.uniqueId !== null && (
                      <Button
                        color="danger"
                        className="saveButton showSave endSession whiteOnClick"
                        onClick={() => {
                          this.onOpenCloseLeaveSessionConfirmationModal(true)
                        }}
                      >
                        {getMessage("LEAVE_SESSION")}
                      </Button>
                    )
                  )}
                <span className="headerRightIcons">
                  <img
                    src={ic_menu}
                    className="saveButton showSave mt-1"
                    onClick={this.openDrawer}
                    title={getMessage("MODULES")}
                  />
                  {this.props.organiser === this.props.uniqueId
                    && waitingParticipants.length > 0
                    && (<span className="badge showBadge saveButton showSave">{waitingParticipants.length}</span>)}
                </span>
              </div>
            </div>

          </Col>
          <Col
            className={
              this.state.popoverOpen
                ? "displayInline overlaySideBar"
                : "displayNone"
            }
          >
            {this.state.popoverOpen && (<Participants
              isSnapshot={false}
              mobileView={true}
              popoverOpen={this.state.popoverOpen}
              openDrawer={this.openDrawer}
              userRole={this.props.userRole}
              handleLeaveSession={this.props.handleLeaveSession}
              handleEndSession={this.props.handleEndSession}
              addInviteeHandle={this.addInviteeHandle}
              makePresenter={this.makePresenter}
              presenter={this.props.presenter}
              isAgent={this.props.organiser === this.props.uniqueId} //this.props.userRole === USER_ROLES.AGENT}
              handleModuleClick={this.handleModuleClick}
              headerIcons={this.props.headerIcons}
              renderModules={this.renderModules}
              handleCancelClick={this.handleCancelClick}
              organiser={this.props.organiser}
              uniqueId={this.props.uniqueId}
              loggingLevel={this.props.loggingLevel}
              saveSessionData={this.props.saveSessionData}
              canvasType={this.props.activeCanvas.canvasType}
              onOpenCloseEndSessionConfirmationModal={this.onOpenCloseEndSessionConfirmationModal}
              onOpenCloseLeaveSessionConfirmationModal={this.onOpenCloseLeaveSessionConfirmationModal}
            />)}
          </Col>
          <Col
            xl="5"
            lg="6"
            md="12"
            xs="12"
            className="parentParticipants displayFlex flexDirectionColumn justifyContentFlexCenter px-lg-0"
          >
            {this.props.headerIcons && (
              <Row className="modules display-webkit-box pt-1 pb-1">{this.renderModules()}</Row>
            )}
          </Col>
          {/* this will be hidden in case of mobile view */}

          <Col xl="3" lg="3" md="12" xs="12" className="parentParticipants px-lg-0 ml-lg-n2 ml-xl-n3">
            {
              <Row className="participants floatRight mx-0">
	            {this.renderScreenMaskingIcon(false)}
                {this.renderRecordingIcon(false)}
                {this.props.organiser === this.props.uniqueId &&
                  this.props.loggingLevel === "ADVANCED" && (
                  <span className="headerRightIcons pt-0 pt-lg-1">
                    <img
                      src={ic_save_icon}
                      className="button cursorPointer"
                      onClick={this.props.saveSessionData}
                      title={getMessage("SAVE")}
                    />
                  </span>
                )}
                <span className="headerRightIcons pt-0 pt-lg-1">
                  <span className="addButton filterImgColor cursorPointer">
                    <div>
                      <img
                        src={ic_participants}
                        className="button"
                        onClick={this.showWaitingArea}
                        title={getMessage("PARTICIPANTS")}
                      />
                      {this.props.organiser === this.props.uniqueId
                        && waitingParticipants.length > 0
                        && (<span className="badge">{waitingParticipants.length}</span>)}
                    </div>
                  </span>
                </span>
                <WaitingArea
                  show={this.state.showWaitingArea}
                  isOrganiser={this.props.organiser === this.props.uniqueId}
                  showWaitingArea={this.showWaitingArea}
                  addInviteeHandle={this.addInviteeHandle}
                  allParticipants={this.state.sortedParticipants}
                  showMakePresenter={this.showMakePresenter}
                  makePresenterPopoverOpen={this.state.makePresenterPopoverOpen}
                  presenter={this.props.presenter}
                  makePresenter={this.makePresenter}
                  isAgent={this.props.organiser === this.props.uniqueId}
                  organiser={this.props.organiser}
                  uniqueId={this.props.uniqueId}
                  canvasType={this.props.activeCanvas.canvasType}
                  showMoreParticipants={this.showMoreParticipants}
                  moreParticipantsPopOver={this.state.moreParticipantsPopOver}
                  sessionLink={this.state.sessionLink}
                  sessionKey={this.props.sessionKey}
                  language={this.props.language}
                  admitOrRejectUserInSession={this.admitOrRejectUserInSession}
                  handleAllowEdit={this.handleAllowEdit}
                  admittedParticipants={this.props.admittedParticipants}
                  evictAction={this.props.evictAction}
                  isReductionLogs={this.props.isReductionLogs}
                />
                {this.props.organiser === this.props.uniqueId ? (
                  <Button
                    className="endSession whiteOnClick"
                    onClick={() => {
                      this.onOpenCloseEndSessionConfirmationModal(true)
                    }}
                  >
                    {getMessage("END_SESSION")}
                  </Button>
                ) :
                  (
                    this.props.organiser !== "" &&
                    this.props.uniqueId !== null && (
                      <Button
                        color="danger"
                        className="endSession whiteOnClick"
                        onClick={() => {
                          this.onOpenCloseLeaveSessionConfirmationModal(true)
                        }}
                      >
                        {getMessage("LEAVE_SESSION")}
                      </Button>
                    )
                  )}
              </Row>
            }
          </Col>
          {this.state.chatPopOver && (
            <ChatContainer
              chatPopOver={this.state.chatPopOver}
              handleClose={this.handleChatToggle}
            />
          )}
          {this.state.locationPopOver && (
            <LocationContainer
              show={this.state.locationPopOver}
              handleLocationToggle={this.handleLocationToggle}
              showSpinner={this.showSpinner}
              hideSpinner={this.hideSpinner}
              handleLocatioNoClick={this.handleLocatioNoClick}
            />
          )}
        </Row>
        {
          this.props.modules && this.props.modules.includes("APP_EMULATION")
            ? <AppEmulationContainer
              show={this.state.showDeviceListModal}
              appEmulationPermisssionReply={this.props.appEmulationPermisssionReply}
              toggle={this.handleAppEmulationToggle}
              checkParticipantsAvailable={this.checkParticipantsAvailable}
              modules={this.props.modules} 
              setAppEmulationStatus={this.setAppEmulationStatus}
            />
            : null
        }

        {
          this.state.showEndSessionConfirmationModal &&

          <EndSessionConfirmationModal
            show={true}
            isDoubleButton={true}
            handleYesClick={() => {
              this.onOpenCloseEndSessionConfirmationModal(false);
              this.handleEndSession();
            }}
            handleNoClick={() => {
              this.onOpenCloseEndSessionConfirmationModal(false);
            }}
            message={
              this.props.loggingLevel !== "ADVANCED"
                ? getMessage("END_SESSION_CONFIRMATION_TEXT")
                : getMessage("END_SESSION_CONFIRMATION_TEXT_ADVANCED")
            }
          />
        }
        {
          this.state.showLeaveSessionConfirmationModal &&

          <EndSessionConfirmationModal
            show={true}
            isDoubleButton={true}
            handleNoClick={() => {
              this.onOpenCloseLeaveSessionConfirmationModal(false);
            }}
            handleYesClick={() => {
              this.onOpenCloseLeaveSessionConfirmationModal(false);
              this.props.handleLeaveSession();
            }}
            message={getMessage("LEAVE_SESSION_CONFIRMATION_TEXT")}
          />
        }
      </div>
    );
  }
}

export default withRouter(Header);
